/*global google*/
import React from "react";
import { useState, useEffect } from "react";
import axios from "axios";
import number from "../../assets/images/number.png"
import downloads from "../../assets/images/downloads.png"
import prints from "../../assets/images/print.png"
import {GoogleMap,useJsApiLoader,Marker,Polygon,MarkerClusterer,InfoWindow,  } from "@react-google-maps/api";
import { MultiSelect } from "react-multi-select-component";
import $ from 'jquery'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {faBars, faArrowCircleDown} from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";



import BlueMarker from '../../assets/images/icon/blue-dot.png';
import PurpleMarker from '../../assets/images/icon/purple-dot.png';
import YellowMarker from '../../assets/images/icon/yellow-dot.png';
import GreenMarker from '../../assets/images/icon/green-dot.png';
import MergentaMarker from '../../assets/images/icon/mergenta-dot.png';
import PinkMarker from '../../assets/images/icon/pink-dot.png';
import DarkGrayMarker from '../../assets/images/icon/darkgray-dot.png';
import DarkGreenMarker from '../../assets/images/icon/darkgreen-dot.png';
import LiteBlueMarker from '../../assets/images/icon/liteblue-dot.png';
import LitegreenMarker from '../../assets/images/icon/litegreen-dot.png';

import LightPurpleMarker from '../../assets/images/icon/lightpurple-dot.png';
import DarkPurpleMarker from '../../assets/images/icon/darkpurple-dot.png';
import LightPinkMarker from '../../assets/images/icon/lightpink-dot.png';
import SuperDarkGreenMarker from '../../assets/images/icon/superdarkgreen-dot.png';

import PinkHomeMarker from '../../assets/images/icon/pink-home.png';
import GreenHomeMarker from '../../assets/images/icon/green-home.png';
import OrangeHomeMarker from '../../assets/images/icon/orange-home.png';
import BlueHomeMarker from '../../assets/images/icon/blue-home.png';
import PurpleHomeMarker from '../../assets/images/icon/purple-home.png';
import GrayHomeMarker from '../../assets/images/icon/gray-home.png';
import SkyBlueMarker from '../../assets/images/icon/skyblue-dot.png'

import BlueCircle from '../../assets/images/icon/Blue-Circle.png';
import { id } from "date-fns/locale";

const containerStyle = {
  width: "100%",
  height: "80vh",
};

function MyComponent() {

  const [map, setMap] = useState(null);
  const [loader, setLoader] = useState(false);
  const [loaderNFSM, setLoaderNFSM] = useState(false);
  const [loaderAIF, setLoaderAIF] = useState(false);
  const [loaderPDMC, setLoaderPDMC] = useState(false)
  const [loaderCotton, setLoaderCotton] = useState(false)
  const [loaderCropic, setLoaderCropic] = useState(false);
  const [mapZoom, setMapZoom] = useState(4);
  const [acabcFilter, setAcabcFilter] = useState("");

  const [statesData, setStatesData] = useState([]);
  const [districtData, setDistrictData] = useState([]);
  const [subDistrictData, setSubDistrictData] = useState([]);
  const [blockData, setBlockData] = useState([]);
  const [villageData, setVillageData] = useState([]);

  const [stateValue, setStateValue] = useState('');
  const [districtValue, setDistrictValue] = useState("");
  const [subDistrictValue, setSubDistrictValue] = useState("");
  const [blockValue, setBlockValue] = useState("");
  const [villageValue, setVillageValue] = useState("");

  const [selected, setSelected] = useState([]);
  const [selectedNBHM, setSelectedNBHM] = useState([]);
  const [mandtFilter, setMandtFilter] = useState([])

  const [ACABCData, setACABCData] = useState([]);
  const [agroforestryData, setAgroforestryData] = useState([]);
  const [AIFData, setAIFData] = useState([]);
  const [AMIData, setAMIData] = useState([]);
  const [MANDTData, setMANDTData] = useState([]);

  const [NBHMDataA, setNBHMDataA] = useState([]);
  const [NBHMDataB, setNBHMDataB] = useState([]);
  const [NBHMDataC, setNBHMDataC] = useState([]);
  const [NBHMDataD, setNBHMDataD] = useState([]);


  const [NFSMData , setNFSMData] = useState([]);
  const[NHBData, setNHBData] = useState([]);
  const [NMEOData, setNMEOData] = useState([]);
  const [PDMCData, setPDMCData] = useState([]);
  const [RADData, setRADData] = useState([]);
  const [SHCFarmerData, setSHCFarmerData] = useState([]);
  const [SHCLabData, setSHCLabData] = useState([]);
  const [cropicData, setCropicData] = useState([]);
  const [RKVYData, setRKVYData] = useState([]);
  const [NaturalFarmingData, setNaturalFarmingData] = useState([]);
  const [MIDHData, setMIDHData] = useState([]);
  const [MOVCDData, setMOVCDData] = useState([]);
  const [NPSSData, setNPSSData] = useState([]);
  const [CottonData, setCottonData] = useState([]);
  const [SeedHubData, setSeedHubData] = useState([]);
  const [LoaderSeedHub, setLoaderSeedHub] = useState(false);
  const [CDBData, setCDBData] = useState([]);
  const [DASDData, setDASDData] = useState([]);
  const [LoaderCDB, setLoaderCDB] = useState(false);
  const [LoaderDASD, setLoaderDASD] = useState(false);
  // All Scheme polygon
  const[ACABCPolygonData, setACABCPolygonData] = useState([]);
  const[agroforestryPolygonData, setAgroforestryPolygonData] = useState([]);
  const[NFSMPolygonData, setNFSMPolygonData] = useState([]);
  const[NHBPolygonData, setNHBPolygonData] = useState([]);
  const[NMEOPolygonData, setNMEOPolygonData] = useState([]);
  const[PDMCPolygonData, setPDMCPolygonData] = useState([]);
  const[RADPolygonData, setRADPolygonData] = useState([]);
  const[SHCFarmerPolygonData, setSHCFarmerPolygonData] = useState([]);
  const[cropicPolygonData, setCropicPolygonData] = useState([]);
  const[naturalFarmingPolygonData, setNaturalFarmingPolygonData] = useState([]);
  const[NBHMDPolygonData, setNBHMDPolygonData] = useState([]);
  const[MIDHPolygonData, setMIDHPolygonData] = useState([]);
  const[MOVCDPolygonData, setMOVCDPolygonData] = useState([]);
  const[CottonPolygonData, setCottonPolygonData] = useState([]);
  const[CDBPolygonData, setCDBPolygonData] = useState([]);
  const[DASDPolygonData, setDASDPolygonData] = useState([]);
  const [activeMarker, setActiveMarker] = useState({});

  const [activeMarkerPoint, setActiveMarkerPoint] = useState({});
  const [activePolygon, setActivePolygon] = useState("");


  const[NFSMarkerData, setNFSMarkerData] = useState([]);

  const [filterCall, setFilterCall] = useState(false);

   const [selectedMarker, setSelectedMarker] = useState(null);
   const markerIcon = ["",GreenMarker, YellowMarker, PinkHomeMarker, GrayHomeMarker, OrangeHomeMarker, GreenHomeMarker, BlueMarker, PinkMarker, PurpleMarker, MergentaMarker, LitegreenMarker, DarkGreenMarker, BlueHomeMarker, DarkGrayMarker, PurpleHomeMarker,LightPurpleMarker, DarkPurpleMarker, LightPinkMarker, SuperDarkGreenMarker, LiteBlueMarker,LiteBlueMarker,LiteBlueMarker,LiteBlueMarker]
   const labelName = ["","Total no. of Survey in ACABC", "Total no. of Survey in Agroforestry", "Total no. of Asset in AIF", "Total no. of Asset in AMI", "Total no. of Asset in M&T - CHC", "Total no. of Asset in NBHM", "Total no. of Farmer in NFSM-CFLD", "Total no. of Survey in NHB-Inspection", "Total no. of Survey in NMEO", "Total no. of Survey in PDMC", "Total no. of Survey in RAD", "Total no. of Survey in SHC-Farmer " , "Total no. of Soil Testing Lab", "Total no. of Survey in Cropic", "Total no. of Asset in RKVY", "Total no. of Survey in Natural Farming", "Total no. of Survey in MIDH", "Total no. of Survey in MOVCD", "Total no. of Survey in NPSS", "Total no. of Survey in NFSM-HDPS Cotton","Total no. of Survey in Seed Hub","Total no. of Survey in CDB","Total no. of Survey in DASD"]
     const optionsScheme = [
       { value: "1", label: "ACABC" },
       { value: "2", label: "AgroForestry" },
       { value: "3", label: "AIF" },
       { value: "4", label: "Agriculture Marketing-AMI" },
       { value: "5", label: "M&T-CHC" },
       { value: "6", label: "NBHM" },
       { value: "7", label: "NFSM-CFLD" },
       { value: "8", label: "NHB-Inspection" },
      //  { value: "9", label: "NMEO" },
       { value: "10", label: "PDMC" },
       { value: "11", label: "RAD" },
       { value: "12", label: "SHC-Farmer" },
       { value: "13", label: "Soil Testing Lab" },
       { value: "14", label: "Cropic" },
       { value: "15", label: "RKVY" },
       { value: "16", label: "Natural Farming" },
       { value: "17", label: "MIDH" },
       { value: "18", label: "MOVCD" },
       { value: "19", label: "NPSS" },
       { value: "20", label: "NFSM-HDPS Cotton" },
       { value: "21", label: "Seed Hub" },
       { value: "22", label: "Cocunut Development Board (CDB)" },
       { value: "23", label: "Directorate of Arecanut and Spices Development (DASD)" },
     ];

     const optionsNBHM = [
      { value: "1", label: "Honey Processing Unit" },
      { value: "2", label: "Honey Testing Unit" },
      { value: "3", label: "Honey CHC" },
      { value: "4", label: "Beeflora Plantation" },
    ];
   
  const [csvArrayData, setCsvArrayData] = useState([{Scheme : "ACABC", TotalCount : 0}, {Scheme : "NFSM-CFLD", TotalCount : 0}, {Scheme: "SHC-Farmer", TotalCount : 0}]);

  const [center, setCenter] = useState({
    lat: 21.977434,
    lng: 78.283474,
  });


  console.log("selected##", selected)
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    // prod
                                    //  googleMapsApiKey : "AIzaSyAr-n9zN3vYDBaPtINPgPQi70DGtHUiyfE"
     // local
                                        googleMapsApiKey: "AIzaSyD4X4kzlpReymgcXUXGh0Q3TalmxJmasM0",
  });


  const onLoad = React.useCallback(function callback(map) {
    setMap(map);
    map.setOptions({ scaleControl: true });
     map.setOptions({ minZoom: 4.5, maxZoom: 20 });
  }, []);

  const onUnmount = React.useCallback(function callback(map) {
    setMap(null);
  }, []);


  function getStates() {
    const fetchStates = async () => {
      const result = await axios(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/states`
      );
      setStatesData(result.data.dataContent);
    };
    fetchStates();
  }

  function handleState(value) {
  
    if(selected.length === 0){
      let classObject = document.getElementsByClassName("schemeSelect")[0];
    
      classObject.addEventListener("change",
     setSelected([
      { value: "1", label: "ACABC" },
      { value: "2", label: "AgroForestry" },
      { value: "3", label: "AIF" },
      { value: "4", label: "Agriculture Marketing-AMI" },
      { value: "5", label: "M&T-CHC" },
      { value: "6", label: "NBHM" },
      { value: "7", label: "NFSM-CFLD" },
      { value: "8", label: "NHB-Inspection" },
      // { value: "9", label: "NMEO" },
      { value: "10", label: "PDMC" },
      { value: "11", label: "RAD" },
      { value: "12", label: "SHC-Farmer" },
      { value: "13", label: "Soil Testing Lab" },
      { value: "14", label: "Cropic" },
      { value: "15", label: "RKVY" },
      { value: "16", label: "Natural Farming" },
      { value: "17", label: "MIDH" },
      { value: "18", label: "MOVCD" },
      { value: "19", label: "NPSS" },
      { value: "20", label: "NFSM-HDPS Cotton" },
      { value: "21", label: "Seed Hub Data" },
      { value: "22", label: "Cocunut Development Board (CDB)" },
       { value: "23", label: "Directorate of Arecanut and Spices Development (DASD)" },
    
    ]));
    }
  
    setStateValue(value);
    if (value === "NA") {
      return;
    }
    setDistrictData([]);
    setDistrictValue("");
    setSubDistrictValue("");

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      stateCode: Number(value),
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/district`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setDistrictData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }

  function handleSubDistrict(value, DDValue) {
   
    setDistrictValue(value);

    if (value === "NA") {
      return;
    }
    if (value != null) {
      var raw = JSON.stringify({
        // subdistrictcode: value,
        districtcode: value,
      });
    } else {
      var raw = JSON.stringify({
        // subdistrictcode: value,
        districtcode: districtValue,
      });
    }

    // setSubDistrictValue(value);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/subdistrict`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setSubDistrictData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }
  function handleBlock(value) {
    setSubDistrictValue(value);
    if (value === "NA") {
      return;
    }

    var raw = JSON.stringify({
      subdistrictcode: value,
      districtcode: districtValue,
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/block`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setBlockData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }

  function handleVillage(value) {
    // setSubDistrictValue(value);
    console.log("block code", blockValue);
    if (value === "NA") {
      return;
    }

    var raw = JSON.stringify({
      blockcode: blockValue,
    });

    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(
      `${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/village`,
      requestOptions
    )
      .then((response) => response.text())
      .then((result) => setVillageData(JSON.parse(result).dataContent))
      .catch((error) => console.log("error", error));
  }


  // Polygon data through scheme

  function ACABCFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/${acabcFilter === "1" ? "Reverse/CommonAPI/PostInstitutionACABC" : "reverse/CommonAPI/PostACABC"}`,
        {  
          state: stateValue === "NA" ? "" : stateValue,
          district: districtValue === "NA" || acabcFilter === "1" ? "" : districtValue,
          village: "",
         
        }
      );
      resolve(y);
    });
  }

  function AgroforestryFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Nature/FarmerDetails/getProjectDetailsList`,
        {  

          "schemeCode": 3,
          // "orgTypeCode": 1,
          // "SurveyUserCode" : 0,
          "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
          "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
          "subDistrictValue": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
          "blockCode": blockValue === "NA"  || blockValue === ""? 0 : blockValue,
          "villageCode" : villageValue === "NA" || villageValue === "" ? 0 : villageValue
         
        }
      );
      resolve(y);
    });
  }

  function AIFFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/reverse/CommonAPI/PostAIFData2`,
        {
          SchemeCode: "Agri Infra Fund",
          state: stateValue === "NA" ? "" : stateValue,
          district: districtValue === "NA" ? "" : districtValue,
          village: villageValue === "NA" ? "" : villageValue,
         
        }
      );
      resolve(y);
    });
  }

  function AMIFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/reverse/CommonAPI/PostAIFData2`,
        {
          SchemeCode: "Agriculture Marketing Infrastructure(DMI)",
          state: stateValue === "NA" ? "" : stateValue,
          district: districtValue === "NA" ? "" : districtValue,
          village: villageValue === "NA" ? "" : villageValue,
         
        }
      );
      resolve(y);
    });
  }

  function MANDTFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Reverse/CommonAPI/${mandtFilter === "1" ? "Get_FMDBT_CHCPolygonHistoryDetails_GIS_Dashboard" : "Get_FMDBT_CHCPolygonDetails_GIS_Dashboard"}`,
        // "https://km.amnex.co.in/appdevapi/api/Reverse/CommonAPI/Get_FMDBT_CHCPolygonDetails_GIS_Dashboard",
        {  
          "stateCode": stateValue === "NA" ||  stateValue === "" ? 0 : stateValue,
          "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
          "subDistrictCode" : subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
          "blockCode": blockValue === "NA" || blockValue === ""  ? 0 : blockValue,
          "revenueVillageCode" : villageValue === "NA" || villageValue === ""? 0 : villageValue
        }
      );
      resolve(y);
    });
  }
  function NBHMAFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Nature/FarmerDetails/getProjectDetailsList`,
        {  

          "schemeCode": 7,
          "orgTypeCode": 1,
          "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
          "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
          "subDistrictValue": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
          "blockCode": blockValue === "NA"  || blockValue === ""? 0 : blockValue,
          "villageCode" : villageValue === "NA" || villageValue === "" ? 0 : villageValue
         
        }
      );
      resolve(y);
    });
  }
  function NBHMBFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Nature/FarmerDetails/getProjectDetailsList`,
        {  

          "schemeCode": 7,
          "orgTypeCode": 2,
          "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
          "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
          "subDistrictValue": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
          "blockCode": blockValue === "NA"  || blockValue === ""? 0 : blockValue,
          "villageCode" : villageValue === "NA" || villageValue === "" ? 0 : villageValue
         
        }
      );
      resolve(y);
    });
  }
  function NBHMCFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Nature/FarmerDetails/getProjectDetailsList`,
        {  

          "schemeCode": 7,
          "orgTypeCode": 3,
          "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
          "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
          "subDistrictValue": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
          "blockCode": blockValue === "NA"  || blockValue === ""? 0 : blockValue,
          "villageCode" : villageValue === "NA" || villageValue === "" ? 0 : villageValue
         
        }
      );
      resolve(y);
    });
  }
  function NBHMDFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Nature/FarmerDetails/getFarmerDetailsList`,
        {  

          "schemeCode": 7,
          "orgTypeCode": 4,
          "SurveyUserCode" : 0,
          "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
          "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
          "subDistrictValue": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
          "blockCode": blockValue === "NA"  || blockValue === ""? 0 : blockValue,
          "villageCode" : villageValue === "NA" || villageValue === "" ? 0 : villageValue
         
        }
      );
      resolve(y);
    });
  }
  function NFSMFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/NFSM/cropDemo/getCropDemoDetailsList`,
        {
          finYear: "",
          cropGroupCode: "",
          cropCode: "",
          seasonName: "",
          stateCode: stateValue === "NA" ? "" : stateValue,
          districtCode: districtValue === "NA" ? "" : districtValue,
          blockCode: blockValue === "NA" ? "" : blockValue,
          villageCode: villageValue === "NA" ? "" : villageValue,
          seasonCode: 0,
        }
      );
      resolve(y);
    });
  }

  function NHBFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/reverse/CommonAPI/PostNHBData`,
        {  
          state: stateValue === "NA" ? "" : stateValue,
          district: districtValue === "NA" ? "" : districtValue,
          village: villageValue === "NA" ? "" : villageValue,
         
        }
      );
      resolve(y);
    });
  }

 
  function NMEOFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Nature/FarmerDetails/getFarmerDetailsList`,
        {  

          "schemeCode": 5,
          "orgTypeCode": 1,
          "SurveyUserCode" : 0,
          "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
          "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
          "subDistrictValue": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
          "blockCode": blockValue === "NA"  || blockValue === ""? 0 : blockValue,
         
        }
      );
      resolve(y);
    });
  }

  function PDMCFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Nature/FarmerDetails/getFarmerDetailsList`,
        {
         
          "schemeCode": 1,
          "orgTypeCode": 1,
          "SurveyUserCode" : 0,
          "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
          "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
          "subDistrictValue": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
          "blockCode": blockValue === "NA"  || blockValue === ""? 0 : blockValue,
          "villageCode": villageValue === "NA"  || villageValue === "" ? 0 : villageValue,
         
        }
      );
      resolve(y);
    });
  }

  function RADFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Nature/FarmerDetails/getFarmerDetailsList`,
        {  

          "schemeCode": 2,
          "orgTypeCode": 1,
          "SurveyUserCode" : 0,
          "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
          "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
          "subDistrictValue": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
          "blockCode": blockValue === "NA"  || blockValue === ""? 0 : blockValue,
         
        }
      );
      resolve(y);
    });
  }


  function SHCFarmerFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Reverse/CommonAPI/SHCFarmerLatLong`,
        {
          "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
          "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
          "subDistrictCode": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
          "blockCode": blockValue === "NA" || blockValue === "" ? 0 : blockValue,
          "villageCode": villageValue === "NA" || villageValue === "" ? 0 : villageValue,
          // "farmerId": ""
         
        }
      );
      resolve(y);
      
    });
  }


  function SHCLabFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/SHC/STLDetails/getSTLDetailsList`,
        {
          farmerName: "",
          email: "",
          phone: "",
          aadharnumber: "",
          stateCode: stateValue === "NA" ? "" : stateValue,
          districtCode: districtValue === "NA" ? "" : districtValue,
          villageCode: villageValue === "NA" ? "" : villageValue,
        }
      );
      resolve(y);
      reject(y)
    });
  }

  function CropicFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/CropSurvey/getGISCropSurveyLatLongList`,
     

        {
         
            "stateCode": stateValue === "NA" || stateValue === "" ? "0" : stateValue,
            "districtCode": districtValue === "NA"  || districtValue === "" ? "0" : districtValue,
            "level4Code": "0",
            "villageCode": "0",
            "orgTypeCode": "",
            "filterYear": "",
            "userTypeCode": 0,
            "filterSeasonCode": 0
          }
      );
      resolve(y);
      reject(y)
    });
  }

  function RKVYFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/RKVY/RKVY/FetchStateWiseRKVYCount`,
        {  

    
          "stateId": stateValue === "NA" || stateValue === "" ? "" : stateValue,
          "districtId": districtValue === "NA" || districtValue === "" ? "" : districtValue,
         
         
        }
      );
      resolve(y);
    });
  }
  function RKVYFetchDataStateWise(value) {

    console.log("value@@@", value)
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/RKVY/RKVY/FetchLatLongRKVY`,
        {  

    
          "StateId":  String(value.stateCode),
          "DistrictId": districtValue === "NA" || districtValue === "" ? "" : districtValue,
         
         
        }
      );
      resolve(y);
    });
  }

  function NaturalFarmingFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Reverse/NaturalFarming/PostNaturalFarmingData`,
        {  
          "stateCode": stateValue === "NA" || stateValue === "" ? 0 : stateValue,
          "districtCode": districtValue === "NA" || districtValue === "" ? 0 : districtValue,
          "subDistrictValue": subDistrictValue === "NA" || subDistrictValue === "" ? 0 : subDistrictValue,
          "blockCode": blockValue === "NA"  || blockValue === ""? 0 : blockValue,
          "villageCode" : villageValue === "NA" || villageValue === "" ? 0 : villageValue
         
        }
      );
      resolve(y);
    });
  }

  function CropicInfoFetchData(value) {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/CropSurvey/getGISCropSurveyList`,
        {
          "cropSurveyCode": value
        }
      );
      resolve(y);
      reject(y)
    });
  }

  function SHCFarmerInfoFetchData(value) {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Reverse/CommonAPI/SHCFarmerDetailsbyFarmerID`,
        {
          "farmerId": String(value)
        }
      );
      resolve(y);
      reject(y)
    });
  }

  function RKVYInfoFetchData(value) {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/RKVY/RKVY/FetchRKVYDetailIdWise`,
        {
          "Id": String(value)
        }
      );
      resolve(y);
      reject(y)
    });
  }

  function MIDHFetchData(value) {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/MIDH/MIDHFarmerDetails/GetMidhFarmerDetailsAsync`,
        {  
          "schemeCode": "8",
          "orgTypeCode": 0,
          "SurveyUserCode": "0",
          "stateCode": stateValue === "NA" || stateValue === "" ? "0" : stateValue,
          "districtCode": districtValue === "NA" || districtValue === "" ? "0" : districtValue,
          "subDistrictCode": subDistrictValue === "NA" || subDistrictValue === "" ? "0" : subDistrictValue,
          "blockCode" : blockValue === "NA" || blockValue === "" ? "0" : blockValue,
          "villageCode" : villageValue === "NA" || villageValue === "" ? "0" : villageValue
        
         
        }
      );
      resolve(y);
      reject(y)
    });
  }

  function MOVCDFetchData(value) {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Nature/FarmerDetails/getFarmerDetailsListNew`,
        {  
          "schemeCode": "9",
          "orgTypeCode": 0,
          "SurveyUserCode": "0",
          "stateCode": stateValue === "NA" || stateValue === "" ? "0" : stateValue,
          "districtCode": districtValue === "NA" || districtValue === "" ? "0" : districtValue,
          "subDistrictCode": subDistrictValue === "NA" || subDistrictValue === "" ? "0" : subDistrictValue,
          "blockCode" : blockValue === "NA" || blockValue === "" ? "0" : blockValue,
          "villageCode" : villageValue === "NA" || villageValue === "" ? "0" : villageValue
        }
      );
      resolve(y);
      reject(y)
    });
  }

  function NPSSFetchData(value) {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/NPSS_ETL/NPSS_ETL/NPSS_ETLData`,
        {
          "stateCode": stateValue === "NA" || stateValue === "" ? "" : stateValue,
          "districtCode": districtValue === "NA" || districtValue === "" ? "" : districtValue,
          "subDistrictCode": subDistrictValue === "NA" || subDistrictValue === "" ? "" : subDistrictValue,
          "villageCode" : villageValue === "NA" || villageValue === "" ? "" : villageValue
        }
      );
      resolve(y);
      reject(y)
    });
  }

  function CottonFetchData(value) {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/Cotton/FetchCottonDetail`,
        {
          "stateId": stateValue === "NA" || stateValue === "" ? "" : stateValue,
          "districtId": districtValue === "NA" || districtValue === "" ? "" : districtValue,
          "blockId": subDistrictValue === "NA" || subDistrictValue === "" ? "" : subDistrictValue,
          "villageId" : villageValue === "NA" || villageValue === "" ? "" : villageValue
        }
      );
      resolve(y);
      reject(y)
    });
  }
  function SeedHubFetchData() {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/SeedHub/FetchSeedHubDetailDashboard`,
        {  

    
          "stateId": stateValue === "NA" || stateValue === "" ? "" : stateValue,
          "districtId": districtValue === "NA" || districtValue === "" ? "" : districtValue,
         "blockId": blockValue === "NA" || blockValue === "" ? "" : blockValue,
         "villageId": villageValue === "NA" || villageValue === "" ? "" : villageValue,
         
        }
      );
      resolve(y);
    });
  }

  function FetchSeedHubLatLongDetails(value) {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/SeedHub/FetchSeedHubLatLongDetails`,
        {  

    
          "stateId": String(value.stateCode),
          "districtId": districtValue === "NA" || districtValue === "" ? "" : districtValue,
         "blockId": blockValue === "NA" || blockValue === "" ? "" : blockValue,
         "villageId": villageValue === "NA" || villageValue === "" ? "" : villageValue,
         
        }
      );
      resolve(y);
    });
  }

  function FetchSeedHubDetailIdWise(value) {
   
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/SeedHub/FetchSeedHubDetailIdWise`,
        {  

    
          "Id": String(value)
         
         
        }
      );
      resolve(y);
    });
  }

  function CDBFetchData(value) {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/CDB/CDB/GetCDBFarmerDetailsAsync`,
        {  
          "schemeCode": "10",
          "orgTypeCode": 0,
          "SurveyUserCode": "0",
          "stateCode": stateValue === "NA" || stateValue === "" ? "0" : stateValue,
          "districtCode": districtValue === "NA" || districtValue === "" ? "0" : districtValue,
          "subDistrictCode": subDistrictValue === "NA" || subDistrictValue === "" ? "0" : subDistrictValue,
          "blockCode" : blockValue === "NA" || blockValue === "" ? "0" : blockValue,
          "villageCode" : villageValue === "NA" || villageValue === "" ? "0" : villageValue
        }
      );
      resolve(y);
      reject(y)
    });
  }

  function DASDFetchData(value) {
    return new Promise((resolve, reject) => {
      const y = axios.post(
        `${
          process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
        }/api/MIDH/MIDHFarmerDetails/GetDasdFarmerDetailsAsync`,
        {  
          "schemeCode": "11",
          "orgTypeCode": 0,
          "SurveyUserCode": "0",
          "stateCode": stateValue === "NA" || stateValue === "" ? "0" : stateValue,
          "districtCode": districtValue === "NA" || districtValue === "" ? "0" : districtValue,
          "subDistrictCode": subDistrictValue === "NA" || subDistrictValue === "" ? "0" : subDistrictValue,
          "blockCode" : blockValue === "NA" || blockValue === "" ? "0" : blockValue,
          "villageCode" : villageValue === "NA" || villageValue === "" ? "0" : villageValue
        }
      );
      resolve(y);
      reject(y)
    });
  }
// Add Marker Task

const handleAddDataACABC = async () => {
  let value = [];
  selected.map((item) => {
    value.push(item.value);
  });

  if (value.includes("1")) {
    setACABCData([]);
    setACABCPolygonData([])
    if(acabcFilter === "") {
      setAcabcFilter("2")
    }
    const resultACABC = await ACABCFetchData();
    setACABCData(resultACABC.data.data);

   document.getElementById("1").innerHTML = resultACABC.data.recordCount;
  
     let items = [...csvArrayData];
     let item = {...items[0]};
     item.TotalCount = resultACABC.data.recordCount;
     items[0] = item;
   setCsvArrayData(items);

   let ACABCPolygonDataLocal = [];

    if (resultACABC.data.data.length > 0) {
      var markerBounds1 = new google.maps.LatLngBounds();
      var randomPoint1, i;
      resultACABC.data.data.map((item) => {
        // randomPoint1 = new google.maps.LatLng(item.latitude, item.longitude);
        // // Draw a marker for each random point
        // new google.maps.Marker({
        //   position: randomPoint1,
        //   // map: map
        // });
        // markerBounds1.extend(randomPoint1);

        let a;
        try {
            a = JSON.parse(item.geoPlotting);
            const bounds = new window.google.maps.LatLngBounds();
            a.forEach(coord => bounds.extend(coord));
            const center = bounds.getCenter();
            // lat: center.lat(), lng: center.lng()
            // console.log("&&&&&", item);
            item.latitude = center.lat();
            item.longitude = center.lng()
            ACABCPolygonDataLocal.push(a)
        } catch (e) {
        }


      });
      // map.fitBounds(markerBounds1);
    
      setACABCPolygonData(ACABCPolygonDataLocal)

    }
  } else {

    let items = [...csvArrayData];
    let item = {...items[0]};
    item.TotalCount = 0;
    items[0] = item;
  setCsvArrayData(items);

    setACABCData([]);
    setACABCPolygonData([]);
  }
};
const handleAddDataAgroforestry = async () => {
  let value = [];
  selected.map((item) => {
    value.push(item.value);
  });

  if (value.includes("2")) {
    setAgroforestryData([]);
    setAgroforestryPolygonData([])
    const resultAgroforestry = await AgroforestryFetchData();
  
    setAgroforestryData(resultAgroforestry.data.dataContent);
     document.getElementById("2").innerHTML = resultAgroforestry.data.recordCount;

    if (resultAgroforestry.data.dataContent.length > 0) {
      var markerBounds = new google.maps.LatLngBounds();

      var randomPoint2, i;
      let agroForestryPolygonDataLocal = [];
    
      resultAgroforestry.data.dataContent.map((item) => {
        randomPoint2 = new google.maps.LatLng(item.farmerCropSurveyPolygonList[0].surveyorLat, item.farmerCropSurveyPolygonList[0].surveyorLong);
        // Draw a marker for each random point
        new google.maps.Marker({
          position: randomPoint2,
          // map: map
        });
        markerBounds.extend(randomPoint2);
         let a;
        try {
            a = JSON.parse(item.farmerCropSurveyPolygonList[0].polygonShape);     
            const bounds = new window.google.maps.LatLngBounds();
            a.forEach(coord => bounds.extend(coord));
            const center = bounds.getCenter();
            item.farmerCropSurveyPolygonList[0].surveyorLat = center.lat();
            item.farmerCropSurveyPolygonList[0].surveyorLong = center.lng()
            console.log("NHB", a, item)       

            agroForestryPolygonDataLocal.push(a)
           
            
        } catch (e) {
         console.log("error", e)
            // return console.error(e); // error in the above string (in this case, yes)!
        }
      });
      map.fitBounds(markerBounds);
       setAgroforestryPolygonData(agroForestryPolygonDataLocal);
    }
  } else {
    setAgroforestryData([]);
    setAgroforestryPolygonData([]);
  }
};

const handleAddDataAIF = async () => {
  let value = [];

  selected.map((item) => {

    value.push(item.value);
  });

  if (value.includes("3")) {
    setLoaderAIF(true)
    setAIFData([]);
    const resultAIF = await AIFFetchData();
   
    setAIFData(resultAIF.data.data);
     document.getElementById("3").innerHTML = resultAIF.data.recordCount;

     if(resultAIF.data.recordCount === 0) {
      setLoaderAIF(false)
      return;
    }

    if (resultAIF.data.data.length > 0) {
      setLoaderAIF(false)
      var markerBounds = new google.maps.LatLngBounds();

      var randomPoint2, i;
      console.log("data@@@@", resultAIF.data.data)
      resultAIF.data.data.map((item) => {
        randomPoint2 = new google.maps.LatLng(item.geoImages[0].geoLatitude, item.geoImages[0].geoLongitude);
        // Draw a marker for each random point
        new google.maps.Marker({
          position: randomPoint2,
          // map: map
        });
        markerBounds.extend(randomPoint2);
      });
      map.fitBounds(markerBounds);
    }
  } else {
    setAIFData([]);
  }
};

const handleAddDataAMI = async () => {
  let value = [];

  selected.map((item) => {

    value.push(item.value);
  });

  if (value.includes("4")) {
    setAMIData([]);
    const resultAMI = await AMIFetchData();
   
    setAMIData(resultAMI.data.data);
     document.getElementById("4").innerHTML = resultAMI.data.recordCount;

    if (resultAMI.data.data.length > 0) {
      var markerBounds = new google.maps.LatLngBounds();

      var randomPoint2, i;
      console.log("data@@@@", resultAMI.data.data)
      resultAMI.data.data.map((item) => {
        randomPoint2 = new google.maps.LatLng(item.geoImages[0].geoLatitude, item.geoImages[0].geoLongitude)
        // Draw a marker for each random point
        new google.maps.Marker({
          position: randomPoint2,
          // map: map
        });
        markerBounds.extend(randomPoint2);
      });
      map.fitBounds(markerBounds);
    }
  } else {
    setAMIData([]);
  }
};

const handleAddDataMANDT = async () => {
  let value = [];

  selected.map((item) => {
   
    value.push(item.value);
  });

  if (value.includes("5")) {
    setMANDTData([]);
    const resultMANDT = await MANDTFetchData();
   
    setMANDTData(resultMANDT.data.data);
     document.getElementById("5").innerHTML = resultMANDT.data.recordCount;
    //  console.log("!!!!!!!!!!!!!1", JSON.parse(resultNHB.data.data[0].photosAndVideos)[0].Latitude)

   console.log("resultMANDT", resultMANDT)

    if (resultMANDT.data.data.length > 0) {
      var markerBounds = new google.maps.LatLngBounds();

      var randomPoint2, i;
    
      // resultMANDT.data.data.map((item) => {
      //   // console.log("NHB DATa $$$$$$$$$$4", JSON.parse(item.photosAndVideos))
       
      //   randomPoint2 = new google.maps.LatLng(item.latitude, item.longitude);
      //   // Draw a marker for each random point
      //   new google.maps.Marker({
      //     position: randomPoint2,
      //     // map: map
      //   });
      //   markerBounds.extend(randomPoint2);

      // });       
      // map.fitBounds(markerBounds);
    }
  } else {
    setMANDTData([]);
  }
};
const handleAddDataNBHM = async () => {
  let value = [];
  selected.map((item) => {
    value.push(item.value);
  });


  if (value.includes("6")) {

    let valueNBHM = [];
    selectedNBHM.map((item) => {
      valueNBHM.push(item.value);
    });

    setNBHMDataA([]);
    setNBHMDataB([]);
    setNBHMDataC([]);
    setNBHMDataD([]);

    let innerHTMLText = ''

    if(valueNBHM.includes("1")){
     
      const resultNBHMA = await NBHMAFetchData();
      setNBHMDataA(resultNBHMA.data.dataContent);
      console.log("resultNBHMA1", resultNBHMA)
      innerHTMLText = innerHTMLText + `HPC-${resultNBHMA.data.recordCount}, `

    }
    if(valueNBHM.includes("2")) {
     
      const resultNBHMB = await NBHMBFetchData();
      setNBHMDataB(resultNBHMB.data.dataContent);
      innerHTMLText = innerHTMLText + `HTU-${resultNBHMB.data.recordCount}, `

    }
    if(valueNBHM.includes("3")) {
     
      const resultNBHMC = await NBHMCFetchData();
      setNBHMDataC(resultNBHMC.data.dataContent);
      innerHTMLText = innerHTMLText + `CHC-${resultNBHMC.data.recordCount}, `

    }
    if(valueNBHM.includes("4")){
      
      const resultNBHMD = await NBHMDFetchData();
      setNBHMDataD(resultNBHMD.data.dataContent);
      innerHTMLText = innerHTMLText + `BP-${resultNBHMD.data.recordCount} `


      if (resultNBHMD.data.dataContent.length > 0) {
       
  
        var i;
        let NBHMDPolygonDataLocal = [];
      
        resultNBHMD.data.dataContent.map((item) => {
    
           let a;
          try {
              a = JSON.parse(item.farmerCropSurveyPolygonList[0].polygonShape);     
              const bounds = new window.google.maps.LatLngBounds();
              a.forEach(coord => bounds.extend(coord));
              const center = bounds.getCenter();
              item.farmerCropSurveyPolygonList[0].surveyorLat = center.lat();
              item.farmerCropSurveyPolygonList[0].surveyorLong = center.lng()
              console.log("NHB", a, item)       
  
              NBHMDPolygonDataLocal.push(a)
             
              
          } catch (e) {
           console.log("error", e)
              // return console.error(e); // error in the above string (in this case, yes)!
          }
        });
         setNBHMDPolygonData(NBHMDPolygonDataLocal);
      }

    }

    
 


   document.getElementById("6").innerHTML = innerHTMLText;

  
  } else {
    setNBHMDataA([]);
    setNBHMDataB([]);
    setNBHMDataC([]);
    setNBHMDataD([]);
  }
  console.log("NBHMAA@@2", NBHMDataA)
};


const handleAddDataNFSM = async () => {
  let value = [];

  selected.map((item) => {
    console.log("item", item, item.value);
    value.push(item.value);
  });

  if (value.includes("7")) {
    setLoaderNFSM(true)
    setNFSMData([]);
    setNFSMPolygonData([])
    const resultNFSM = await NFSMFetchData();

    setNFSMData(resultNFSM.data.dataContent);
    document.getElementById("7").innerHTML = resultNFSM.data.recordCount;
    csvArrayData[1].TotalCount = resultNFSM.data.recordCount;
    if(resultNFSM.data.recordCount === 0) {
      setLoaderNFSM(false)
      return;
    }

    if (resultNFSM.data.dataContent.length > 0) {
      setLoaderNFSM(false)
      var markerBounds = new google.maps.LatLngBounds();

      var randomPoint, i;


      let NFSMPolygonDataLocal = [];
      
      resultNFSM.data.dataContent.map((item) => {
      
        let a;
        try {
            a = JSON.parse(item.geoPlotting);
            const bounds = new window.google.maps.LatLngBounds();
            a.forEach(coord => bounds.extend(coord));
            const center = bounds.getCenter();
            // lat: center.lat(), lng: center.lng()
            // console.log("&&&&&", item);
            item.latitude = center.lat();
            item.longitude = center.lng()
            NFSMPolygonDataLocal.push(a)
        } catch (e) {
            // return console.error(e); // error in the above string (in this case, yes)!
        }
      });
      setNFSMPolygonData(NFSMPolygonDataLocal)
    }
  } else {
    setNFSMData([]);
    setNFSMPolygonData([])
  }
};

const handleAddDataNHB = async () => {
  let value = [];


  selected.map((item) => {
   
    value.push(item.value);
  });

  if (value.includes("8")) {
    setNHBData([]);
    setNHBPolygonData([])
    const resultNHB = await NHBFetchData();
   
    setNHBData(resultNHB.data.data);
     document.getElementById("8").innerHTML = resultNHB.data.recordCount;
    //  console.log("!!!!!!!!!!!!!1", JSON.parse(resultNHB.data.data[0].photosAndVideos)[0].Latitude)

   

    if (resultNHB.data.data.length > 0) {
      var markerBounds = new google.maps.LatLngBounds();

      var randomPoint2, i;
      let NHBPolygonDataLocal = [];
      resultNHB.data.data.map((item) => {
        // console.log("NHB DATa $$$$$$$$$$4", JSON.parse(item.photosAndVideos))
        // item = JSON.parse(item)
        randomPoint2 = new google.maps.LatLng(item.polygons[0].lat, item.polygons[0].lng);
        // Draw a marker for each random point
        new google.maps.Marker({
          position: randomPoint2,
          // map: map
        });
        markerBounds.extend(randomPoint2);

        let a;
        try {
            a = JSON.parse(item.polygonData);     
            const bounds = new window.google.maps.LatLngBounds();
            a.forEach(coord => bounds.extend(coord));
            const center = bounds.getCenter();
            item.polygons[0].lat = center.lat();
            item.polygons[0].lng = center.lng()
            console.log("NHB", a, item)       

            NHBPolygonDataLocal.push(a)
           
            
        } catch (e) {
         
            // return console.error(e); // error in the above string (in this case, yes)!
        }
      });
      map.fitBounds(markerBounds);
      setNHBPolygonData(NHBPolygonDataLocal)
      console.log("NHBPolygonDataLocal", NHBPolygonDataLocal)
    }
  } else {
    setNHBData([]);
    setNHBPolygonData([])
  }
};
const handleAddDataNMEO = async () => {
  let value = [];
  selected.map((item) => {
    value.push(item.value);
  });

  if (value.includes("9")) {
    setNMEOData([]);
    setNMEOPolygonData([])
    const resultNMEO = await NMEOFetchData();
  
    setNMEOData(resultNMEO.data.dataContent);
     document.getElementById("9").innerHTML = resultNMEO.data.recordCount;

    if (resultNMEO.data.dataContent.length > 0) {
      var markerBounds = new google.maps.LatLngBounds();

      var randomPoint2, i;
      let NMEOPolygonDataLocal = [];
      resultNMEO.data.dataContent.map((item) => {
        // console.log("NHB DATa $$$$$$$$$$4", JSON.parse(item.photosAndVideos))
        // item = JSON.parse(item)
        randomPoint2 = new google.maps.LatLng(item.farmerCropSurveyPolygonList[0].surveyorLat, item.farmerCropSurveyPolygonList[0].surveyorLong);
        // Draw a marker for each random point
        new google.maps.Marker({
          position: randomPoint2,
          // map: map
        });
        markerBounds.extend(randomPoint2);

        let a;
        try {
          a = JSON.parse(item.farmerCropSurveyPolygonList[0].polygonShape);
            const bounds = new window.google.maps.LatLngBounds();
            a.forEach(coord => bounds.extend(coord));
            const center = bounds.getCenter();
            // lat: center.lat(), lng: center.lng()
            // console.log("&&&&&", item);
            item.farmerCropSurveyPolygonList[0].surveyorLat = center.lat();
            item.farmerCropSurveyPolygonList[0].surveyorLong = center.lng()
            NMEOPolygonDataLocal.push(a)
        } catch (e) {
            // return console.error(e); // error in the above string (in this case, yes)!
        }


      });
      map.fitBounds(markerBounds);
      setNMEOPolygonData(NMEOPolygonDataLocal)
    }
  } else {
    setNMEOData([]);
    setNMEOPolygonData([])
  }
};
const handleAddDataPDMC = async () => {
  let value = [];

  selected.map((item) => {
   
    value.push(item.value);
  });

  if (value.includes("10")) {
    setLoaderPDMC(true)
    setPDMCData([]);
    setPDMCPolygonData([])
    const resultPDMC = await PDMCFetchData();
  
    setPDMCData(resultPDMC.data.dataContent);
     document.getElementById("10").innerHTML = resultPDMC.data.recordCount;

     if(resultPDMC.data.recordCount === 0) {
      setLoaderPDMC(false)
      return;
    }

    if (resultPDMC.data.dataContent.length > 0) {
      setLoaderPDMC(false)
      var markerBounds = new google.maps.LatLngBounds();

      var randomPoint2, i;
      let PDMCPolygonDataLocal = [];
      resultPDMC.data.dataContent.map((item) => {
        // console.log("NHB DATa $$$$$$$$$$4", JSON.parse(item.photosAndVideos))
        // item = JSON.parse(item)
      //  randomPoint2 = new google.maps.LatLng(item.farmerCropSurveyPolygonList[0].surveyorLat, item.farmerCropSurveyPolygonList[0].surveyorLong);
        // Draw a marker for each random point
        // new google.maps.Marker({
        //   position: randomPoint2,
        //   // map: map
        // });
        // markerBounds.extend(randomPoint2);

        let a;
        try {
          if(item.surveyNo !== "136") {
            a = JSON.parse(item.farmerCropSurveyPolygonList[0].polygonShape);
            const bounds = new window.google.maps.LatLngBounds();
            a.forEach(coord => bounds.extend(coord));
            const center = bounds.getCenter();
            // lat: center.lat(), lng: center.lng()
            // console.log("&&&&&", item);
            item.farmerCropSurveyPolygonList[0].surveyorLat = center.lat();
            item.farmerCropSurveyPolygonList[0].surveyorLong = center.lng()
            PDMCPolygonDataLocal.push(a)

          }
          
        } catch (e) {
            // return console.error(e); // error in the above string (in this case, yes)!
        }


      });
      // map.fitBounds(markerBounds);
      setNMEOPolygonData(PDMCPolygonDataLocal)
    }
  } else {
    setPDMCData([]);
    setPDMCPolygonData([])
  }
};

const handleAddDataRAD = async () => {
  let value = [];
  selected.map((item) => {
    value.push(item.value);
  });

  if (value.includes("11")) {
    setRADData([]);
    setRADPolygonData([])
    const resultRAD = await RADFetchData();
  
    setRADData(resultRAD.data.dataContent);
     document.getElementById("11").innerHTML = resultRAD.data.recordCount;

    if (resultRAD.data.dataContent.length > 0) {
      var markerBounds = new google.maps.LatLngBounds();

      var randomPoint2, i;
      let RADPolygonDataLocal = [];
      resultRAD.data.dataContent.map((item) => {
        // console.log("NHB DATa $$$$$$$$$$4", JSON.parse(item.photosAndVideos))
        // item = JSON.parse(item)
        if (item.farmerCropSurveyPolygonList.length === 0) {

        }else {
          randomPoint2 = new google.maps.LatLng(item.farmerCropSurveyPolygonList[0].surveyorLat, item.farmerCropSurveyPolygonList[0].surveyorLong);
          // Draw a marker for each random point
          new google.maps.Marker({
            position: randomPoint2,
            // map: map
          });
          markerBounds.extend(randomPoint2);
  
          let a;
          try {
              a = JSON.parse(item.farmerCropSurveyPolygonList[0].polygonShape);
              const bounds = new window.google.maps.LatLngBounds();
              a.forEach(coord => bounds.extend(coord));
              const center = bounds.getCenter();
              // lat: center.lat(), lng: center.lng()
              // console.log("&&&&&", item);
              item.farmerCropSurveyPolygonList[0].surveyorLat = center.lat();
              item.farmerCropSurveyPolygonList[0].surveyorLong = center.lng()
              RADPolygonDataLocal.push(a)
          } catch (e) {
              // return console.error(e); // error in the above string (in this case, yes)!
          }
  

        }
       

      });
      map.fitBounds(markerBounds);
      setRADPolygonData(RADPolygonDataLocal)
    }
  } else {
    setRADData([]);
    setRADPolygonData([])
  }
};

const handleAddDataSHCFarmer = async () => {
  let value = [];

  selected.map((item) => {
  
    value.push(item.value);
  });

  if (value.includes("12")) {
    setLoader(true)
    setSHCFarmerData([]);
    setSHCFarmerPolygonData([])
    const resultFarmer = await SHCFarmerFetchData();

    console.log("resultFarmer!!!", resultFarmer)

    setSHCFarmerData(resultFarmer.data.data);
     document.getElementById("12").innerHTML = resultFarmer.data.recordCount;
     csvArrayData[2].TotalCount = resultFarmer.data.recordCount;
     console.log("resultFarmer", resultFarmer)

     if(resultFarmer.data.recordCount === 0) {
      console.log("resultFarmer!!!22", resultFarmer)
      setLoader(false)
      return;
    }

 

     if (resultFarmer.data.recordCount > 0) {
      console.log("resultFarmer!!!33", resultFarmer)
      setLoader(false)
      return;
     }
    //   var markerBounds = new google.maps.LatLngBounds();

    //   var randomPoint2, i;
    //   console.log("data@@@@", resultFarmer.data.data)
    //   resultFarmer.data.data.map((item) => {
    //     randomPoint2 = new google.maps.LatLng(item.latitudeCoordinate, item.longitudeCoordinate);
    //     // Draw a marker for each random point
    //     new google.maps.Marker({
    //       position: randomPoint2,
    //       // map: map
    //     });
    //     markerBounds.extend(randomPoint2);
    //   });
    //   map.fitBounds(markerBounds);
    // }
  } else {
    setSHCFarmerData([]);
    setSHCFarmerPolygonData([])
  }

};

  const handleAddDataSHCLab = async () => {
    let value = [];

    selected.map((item) => {
    
      value.push(item.value);
    });

    if (value.includes("13")) {
      
      setSHCLabData([]);
    
      const resultSHCLab = await SHCLabFetchData();
      setSHCLabData(resultSHCLab.data.dataContent);
      console.log("resultSHCLab" ,resultSHCLab)
     document.getElementById("13").innerHTML = resultSHCLab.data.recordCount;

      if (resultSHCLab.data.dataContent.length > 0) {
        var markerBounds1 = new google.maps.LatLngBounds();

        var randomPoint1, i;

        resultSHCLab.data.dataContent.map((item) => {
          randomPoint1 = new google.maps.LatLng(item.latitude, item.longitude);
          // Draw a marker for each random point
          new google.maps.Marker({
            position: randomPoint1,
            // map: map
          });
          markerBounds1.extend(randomPoint1);
        });
        map.fitBounds(markerBounds1);
      }
    } else {
      setSHCLabData([]);
    }
  };

  const handleAddDataCropic = async () => {
    let value = [];

    selected.map((item) => {
    
      value.push(item.value);
    });

    if (value.includes("14")) {
      setCropicPolygonData([])
      setCropicData([]);
      setLoaderCropic(true)
    
      const resultCropic = await CropicFetchData();
      setCropicData(resultCropic.data.dataContent);
      console.log("resultCropic" ,resultCropic)
     document.getElementById("14").innerHTML = resultCropic.data.recordCount;

     if(resultCropic.data.recordCount === 0) {
      setLoaderCropic(false)
      return;
    }

    if (resultCropic.data.dataContent.length > 0) {
      setLoaderCropic(false)
      return;
    }

      // if (resultCropic.data.dataContent.length > 0) {
      //   var markerBounds1 = new google.maps.LatLngBounds();

      //   var randomPoint1, i;

      //   resultCropic.data.dataContent.map((item) => {
      //     randomPoint1 = new google.maps.LatLng(item.surveyorLat, item.surveyorLong);
      //     // Draw a marker for each random point
      //     new google.maps.Marker({
      //       position: randomPoint1,
      //       // map: map
      //     });
      //     markerBounds1.extend(randomPoint1);
      //   });
      //   map.fitBounds(markerBounds1);
  //     let cropicPolygonDataLocal = [];
  // resultCropic.data.dataContent.map((item) => {
  //     let a;
  //     try {
  //       console.log("item", item)
  //         a = JSON.parse(item.cropSurveyPolygonList[0].polygonShape);
  //         const bounds = new window.google.maps.LatLngBounds();
  //         a.forEach(coord => bounds.extend(coord));
  //         const center = bounds.getCenter();
  //         // lat: center.lat(), lng: center.lng()
  //         // console.log("&&&&&", item);
  //         item.cropSurveyPolygonList[0].surveyorLat = center.lat();
  //         item.cropSurveyPolygonList[0].surveyorLong = center.lng()
  //         cropicPolygonDataLocal.push(a)
  //     } catch (e) {
  //         // return console.error(e); // error in the above string (in this case, yes)!
  //         console.log("error", a)
  //     }
  //   })

    // setCropicPolygonData(cropicPolygonDataLocal)


    } else {
      setCropicData([]);
      setCropicPolygonData([])
    }
  };

  

  const handleAddDataRKVY = async () => {
    let value = [];
    selected.map((item) => {
      value.push(item.value);
    });
  
    if (value.includes("15")) {
      setRKVYData([]);
      const resultRKVY = await RKVYFetchData();
    
      setRKVYData(resultRKVY.data.dataContent);
       document.getElementById("15").innerHTML = resultRKVY.data.recordCount;
  
      if (resultRKVY.data.dataContent.length > 0) {
        var markerBounds = new google.maps.LatLngBounds();
  

        // resultRKVY.data.dataContent.map((item) => {
        //   var markerBounds = new google.maps.LatLngBounds();

        //   var randomPoint2, i;
        
        //   resultRKVY.data.dataContent.map((item) => {
        //     randomPoint2 = new google.maps.LatLng(item.latitude, item.longitude);
        //     // Draw a marker for each random point
        //     new google.maps.Marker({
        //       position: randomPoint2,
        //       // map: map
        //     });
        //     markerBounds.extend(randomPoint2);
        //   });
        //   map.fitBounds(markerBounds);
  
  
        // });
        // map.fitBounds(markerBounds);
      
      }
    } else {
      setRKVYData([]);
    }
  };
  const handleAddDataNaturalFarming = async () => {
    let value = [];
    selected.map((item) => {
      value.push(item.value);
    });
  
    if (value.includes("16")) {
      setNaturalFarmingData([]);
      setNaturalFarmingPolygonData([])
      const resultNaturalFarming = await NaturalFarmingFetchData();
    
      setNaturalFarmingData(resultNaturalFarming.data.data);
       document.getElementById("16").innerHTML = resultNaturalFarming.data.recordCount;
  
      if (resultNaturalFarming.data.data.length > 0) {
        var markerBounds = new google.maps.LatLngBounds();
  
        var randomPoint2, i;
        let NaturalFarmingPolygonDataLocal = [];
        resultNaturalFarming.data.data.map((item) => {
          // console.log("NHB DATa $$$$$$$$$$4", JSON.parse(item.photosAndVideos))
          // item = JSON.parse(item)
          // randomPoint2 = new google.maps.LatLng(item.farmerCropSurveryPolygon[0].surveyorLat, item.farmerCropSurveryPolygon[0].surveyorLong);
          // // Draw a marker for each random point
          // new google.maps.Marker({
          //   position: randomPoint2,
          //   // map: map
          // });
          // markerBounds.extend(randomPoint2);
  
          let a;
          try {
              a = JSON.parse(item.farmerCropSurveryPolygon[0].polygonShape);
              const bounds = new window.google.maps.LatLngBounds();
              a.forEach(coord => bounds.extend(coord));
              const center = bounds.getCenter();
              // lat: center.lat(), lng: center.lng()
              // console.log("&&&&&", item);
              item.farmerCropSurveryPolygon[0].surveyorLat = center.lat();
              item.farmerCropSurveryPolygon[0].surveyorLong = center.lng()
              NaturalFarmingPolygonDataLocal.push(a)
              console.log("fixed", a)
          } catch (e) {
              return console.error("error inn natural farming",e); // error in the above string (in this case, yes)!
          }
  
  
        });
        // map.fitBounds(markerBounds);
        setNaturalFarmingPolygonData(NaturalFarmingPolygonDataLocal)
      }
    } else {
      setNaturalFarmingData([]);
      setNaturalFarmingPolygonData([])
    }
  };

  const handleAddDataMIDH = async () => {
    let value = [];
  
    selected.map((item) => {
  
      value.push(item.value);
    });
  
    if (value.includes("17")) {
      setMIDHData([]);
      const resultMIDH = await MIDHFetchData();
     
      setMIDHData(resultMIDH.data.dataContent);
       document.getElementById("17").innerHTML = resultMIDH.data.recordCount;
  
      if (resultMIDH.data.dataContent.length > 0) {
      
  
        var randomPoint2, i;
        let MIDHPolygonDataLocal = [];
        console.log("data@@@@", resultMIDH.data.dataContent)
        resultMIDH.data.dataContent.map((item) => {

          let a;
          try {
              a = JSON.parse(item.farmerCropSurveyPolygonList[0].polygonShape);
              const bounds = new window.google.maps.LatLngBounds();
              a.forEach(coord => bounds.extend(coord));
              const center = bounds.getCenter();
              // lat: center.lat(), lng: center.lng()
              // console.log("&&&&&", item);
              item.farmerCropSurveyPolygonList[0].surveyorLat = center.lat();
              item.farmerCropSurveyPolygonList[0].surveyorLong = center.lng()
              MIDHPolygonDataLocal.push(a)
              console.log("fixed", a)
          } catch (e) {
              return console.error("error in MIDH",e); // error in the above string (in this case, yes)!
          }
      
        });
        setMIDHPolygonData(MIDHPolygonDataLocal)
        
      }
    } else {
      setMIDHData([]);
      setMIDHPolygonData([])
    }
  };

  const handleAddDataMOVCD = async () => {
    let value = [];
  
    selected.map((item) => {
  
      value.push(item.value);
    });
  
    if (value.includes("18")) {
      setMOVCDData([]);
      const resultMOVCD = await MOVCDFetchData();
     
      setMOVCDData(resultMOVCD.data.dataContent);
       document.getElementById("18").innerHTML = resultMOVCD.data.recordCount;
  
      if (resultMOVCD.data.dataContent.length > 0) {
      
  
        var randomPoint2, i;
        let MOVCDPolygonDataLocal = [];
       
        resultMOVCD.data.dataContent.map((item) => {

          let a;
          try {
              a = JSON.parse(item.farmerCropSurveyPolygonList[0].polygonShape);
              const bounds = new window.google.maps.LatLngBounds();
              a.forEach(coord => bounds.extend(coord));
              const center = bounds.getCenter();
              // lat: center.lat(), lng: center.lng()
              // console.log("&&&&&", item);
              item.farmerCropSurveyPolygonList[0].surveyorLat = center.lat();
              item.farmerCropSurveyPolygonList[0].surveyorLong = center.lng()
              MOVCDPolygonDataLocal.push(a)
              console.log("fixed", a)
          } catch (e) {
              return console.error("error in MIDH",e); // error in the above string (in this case, yes)!
          }
      
        });
        setMOVCDPolygonData(MOVCDPolygonDataLocal)
        
      }
    } else {
      setMOVCDData([]);
      setMOVCDPolygonData([])
    }
  };

  const handleAddDataNPSS = async () => {
    let value = [];
  
    selected.map((item) => {
  
      value.push(item.value);
    });
  
    if (value.includes("19")) {
      setNPSSData([]);
      const resultNPSS = await NPSSFetchData();
     
      setNPSSData(resultNPSS.data.dataContent);
       document.getElementById("19").innerHTML = resultNPSS.data.recordCount;
  
    } else {
      setNPSSData([]);
    
    }
  };

  const handleAddDataCotton = async () => {
    let value = [];
  
    selected.map((item) => {
  
      value.push(item.value);
    });
  
    if (value.includes("20")) {
      setLoaderCotton(true)
      setCottonData([]);
      const resultCotton = await CottonFetchData();
     
      setCottonData(resultCotton.data.dataContent);
       document.getElementById("20").innerHTML = resultCotton.data.recordCount;

       if(resultCotton.data.recordCount === 0) {
        setLoaderCotton(false)
        return;
      }
  
      if (resultCotton.data.dataContent.length > 0) {
        setLoaderCotton(false)
  
        var randomPoint2, i;
        let CottonPolygonDataLocal = [];
       
        resultCotton.data.dataContent.map((item) => {

          let a;
          try {
              a = JSON.parse(item.land_coordinate);
              const bounds = new window.google.maps.LatLngBounds();
              a.forEach(coord => bounds.extend(coord));
              const center = bounds.getCenter();
              // lat: center.lat(), lng: center.lng()
              // console.log("&&&&&", item);
              item.surveyorLat = center.lat();
              item.surveyorLong = center.lng()
              CottonPolygonDataLocal.push(a)
             
          } catch (e) {
              return console.error("error in Cotton",e); // error in the above string (in this case, yes)!
          }
      
        });
        setCottonPolygonData(CottonPolygonDataLocal)
        
      }
    } else {
      setCottonData([]);
      setCottonPolygonData([])
    }
  };

  const handleAddDataSeedHub = async () => {
    let value = [];
    selected.map((item) => {
      value.push(item.value);
    });
  
    if (value.includes("21")) {
      setLoaderSeedHub(true);
      setSeedHubData([]);
      const resultSeedHub = await SeedHubFetchData();
    
      setSeedHubData(resultSeedHub.data.dataContent);
       document.getElementById("21").innerHTML = resultSeedHub.data.recordCount;
  
      if (resultSeedHub.data.dataContent.length > 0) {
        setLoaderSeedHub(false);
        var markerBounds = new google.maps.LatLngBounds();
      }
    } else {
      setSeedHubData([]);
    }
  };

  const handleAddDataCDB = async () => {
    let value = [];
  
    selected.map((item) => {
  
      value.push(item.value);
    });
  
    if (value.includes("22")) {
      setLoaderCDB(true);
      setCDBData([]);
      const resultCDB = await CDBFetchData();
     
      setCDBData(resultCDB.data.dataContent);
       document.getElementById("22").innerHTML = resultCDB.data.recordCount;
  
      if (resultCDB.data.dataContent.length > 0) {
        setLoaderCDB(false);
  
        var randomPoint2, i;
        let CDBPolygonDataLocal = [];
       
        resultCDB.data.dataContent.map((item) => {

          let a;
          try {
              a = JSON.parse(item.farmerCropSurveyPolygonList[0].polygonShape);
              const bounds = new window.google.maps.LatLngBounds();
              a.forEach(coord => bounds.extend(coord));
              const center = bounds.getCenter();
              // lat: center.lat(), lng: center.lng()
              // console.log("&&&&&", item);
              item.farmerCropSurveyPolygonList[0].surveyorLat = center.lat();
              item.farmerCropSurveyPolygonList[0].surveyorLong = center.lng()
              CDBPolygonDataLocal.push(a)
              console.log("fixed", a)
          } catch (e) {
              return console.error("error in CDB",e); // error in the above string (in this case, yes)!
          }
      
        });
        setCDBPolygonData(CDBPolygonDataLocal)
        
      }
    } else {
      setCDBData([]);
      setCDBPolygonData([]);
     
    }
  };

  const handleAddDataDASD = async () => {
    let value = [];
  
    selected.map((item) => {
  
      value.push(item.value);
    });
  
    if (value.includes("23")) {
      setLoaderDASD(true);
      setDASDData([]);
      const resultDASD = await DASDFetchData();
     
      setDASDData(resultDASD.data.dataContent);
       document.getElementById("23").innerHTML = resultDASD.data.recordCount;
  
      if (resultDASD.data.dataContent.length > 0) {
      
        setLoaderDASD(false);
        var randomPoint2, i;
        let DASDPolygonDataLocal = [];
       
        resultDASD.data.dataContent.map((item) => {

          let a;
          try {
              a = JSON.parse(item.farmerCropSurveyPolygonList[0].polygonShape);
              const bounds = new window.google.maps.LatLngBounds();
              a.forEach(coord => bounds.extend(coord));
              const center = bounds.getCenter();
              // lat: center.lat(), lng: center.lng()
              // console.log("&&&&&", item);
              item.farmerCropSurveyPolygonList[0].surveyorLat = center.lat();
              item.farmerCropSurveyPolygonList[0].surveyorLong = center.lng()
              DASDPolygonDataLocal.push(a)
              console.log("fixed", a)
          } catch (e) {
              return console.error("error in DASD",e); // error in the above string (in this case, yes)!
          }
      
        });
        setDASDPolygonData(DASDPolygonDataLocal)
        
      }
    } else {
      setDASDData([]);
      setDASDPolygonData([])
    }
  };
  // function handleHomeButton() {
  //   handleAddDataSeedHub();
  // }


    
  function handleAddMarker() {
    
    selected.map((item) => {
   
    })
    setFilterCall(true);
    handleAddDataACABC();
    handleAddDataAgroforestry();
    //handleAddDataAIF();
    handleAddDataAMI();
    handleAddDataMANDT();
    handleAddDataNBHM();
    handleAddDataNFSM();
    handleAddDataNHB();
    handleAddDataNMEO();
    handleAddDataPDMC();
    handleAddDataRAD();
    handleAddDataSHCFarmer();
    handleAddDataSHCLab();
    handleAddDataCropic();
    handleAddDataRKVY();
    handleAddDataNaturalFarming();
    handleAddDataMIDH();
    handleAddDataMOVCD();
    handleAddDataNPSS();
    handleAddDataCotton();
    handleAddDataSeedHub();
    handleAddDataCDB();
    handleAddDataDASD();
    document.getElementById('legend').style.display='block'
    document.getElementById('count').style.display='block'
    
  }

  function handleClear() {
    setActiveMarkerPoint({})
    setActivePolygon("")
    setSelected([]);
    setStateValue("");
    setDistrictValue("");
    setSubDistrictValue("");
    setBlockValue("");
    setVillageValue("");

    setStatesData([]);
    setDistrictData([]);
    setSubDistrictData([]);
    setBlockData([]);
    setVillageData([]);

    setACABCData([]);
    setAgroforestryData([]);
    setAIFData([]);
    setAMIData([]);
    setMANDTData([]);
    setNBHMDataA([]);
    setNBHMDataB([]);
    setNBHMDataC([]);
    setNBHMDataD([]);
    setNFSMData([]);
    setNHBData([])
    setNMEOData([]);
    setPDMCData([]);
    setRADData([]);
    setSHCFarmerData([]);
    setSHCLabData([]);
    setCropicData([]);
    setRKVYData([]);
    setNaturalFarmingData([]);
    setMIDHData([]);
    setMOVCDData([]);
    setNPSSData([]);
    setCottonData([]);
    setSeedHubData([]);
    setCDBData([]);
    setDASDData([]);
    setACABCPolygonData([])
    setAgroforestryPolygonData([])
    setNFSMPolygonData([])
    setNHBPolygonData([])
    setNMEOPolygonData([])
    setPDMCPolygonData([])
    setRADPolygonData([])
    setSHCFarmerPolygonData([])
    setCropicPolygonData([])
    setNaturalFarmingPolygonData([])
    setMIDHPolygonData([])
    setMOVCDPolygonData([])
    setCottonPolygonData([])
    setCDBPolygonData([])
    setDASDPolygonData([])

    map.setOptions({ minZoom: 4.5, maxZoom: 20 });
    setCenter({
      lat: 21.977434,
      lng: 78.283474,
    })
    // setMapZoom(4)
    map.setZoom(4)
    document.getElementById('legend').style.display='none'
    document.getElementById('count').style.display='none'

    document.getElementById('infoDetailsACABC').style.display='none';
    document.getElementById('infoDetailsAgroforestry').style.display='none'
    document.getElementById('infoDetailsAIF').style.display='none'
    document.getElementById('infoDetailsAMI').style.display='none'
    document.getElementById('infoDetailsMANDT').style.display='none'
    document.getElementById('infoDetailsNBHM').style.display='none';
    document.getElementById('infoDetailsNFSM').style.display='none'
    document.getElementById('infoDetailsNHB').style.display='none'
    document.getElementById('infoDetailsNMEO').style.display='none'
    document.getElementById('infoDetailsPDMC').style.display='none'
    document.getElementById('infoDetailsRAD').style.display='none'
    document.getElementById('infoDetailsSHCFarmer').style.display='none'
    document.getElementById('infoDetailsSHCLab').style.display='none'
    document.getElementById('infoDetailsCropic').style.display='none'
    document.getElementById('infoDetailsRKVY').style.display='none'
    document.getElementById('infoDetailsNaturalFarming').style.display='none'
    document.getElementById('infoDetailsMIDH').style.display='none'
    document.getElementById('infoDetailsMOVCD').style.display='none'
    document.getElementById('infoDetailsNPSS').style.display='none'
    document.getElementById('infoDetailsCotton').style.display='none'
    document.getElementById('infoDetailsSeedHub').style.display='none'
     document.getElementById('infoDetailsDASD').style.display='none'
     document.getElementById('infoDetailsCDB').style.display='none'

  }

//   const handleMarkerClickSoil = (marker1) => {
//     let contentStringSoil = `<div class="table-responsive imgthumbnails"><table class="table">
//     <tr><th>State  : &nbsp</th><td>${marker1.stateName}</td></tr>
//     <tr><th>District : &nbsp</th><td>${marker1.districtName}</td></tr>
//     <tr><th>Farmer Name : &nbsp</th><td>${marker1.farmerName}</td></tr>
//     <tr><th>Farmer Address : &nbsp</th><td>${marker1.farmerAddress}</td></tr>
//     <tr><th>Farmer Name : &nbsp</th><td>${marker1.farmerName}</td></tr>
//     <tr><th>Lab Type: &nbsp</th><td>${marker1.labType}</td></tr>
//     <tr><th>Lab Name : &nbsp</th><td>${marker1.testCenterName}</td></tr>
//     <tr><th>Scheme Name : &nbsp</th><td>Soil Testing Lab</td></tr>
//     <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsSoil').style.display='none'">Close</button></th></tr>
//     </table></div>`;  
//     document.getElementById("infoDetailsSoil").style.display = "block";
//     document.getElementById("infoDetailsSoil").innerHTML = contentStringSoil
//   }

//   const handleMarkerClickFarmer = (marker1) => {
//     let contentStringFarmer = `<div class="table-responsive imgthumbnails"><table class="table">
//     <tr><th>State  : &nbsp</th><td>${marker1.stateName}</td></tr>
//     <tr><th>District : &nbsp</th><td>${marker1.districtName}</td></tr>
//     <tr><th>Village : &nbsp</th><td>${marker1.villageName}</td></tr>
//     <tr><th>Farmer Name : &nbsp</th><td>${marker1.farmerName}</td></tr>
//     <tr><th>Farmer Address : &nbsp</th><td>${marker1.farmerAddress}</td></tr>
//     <tr><th>Scheme Name : &nbsp</th><td>SHC- Farmer</td></tr>
//     <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsFarmer').style.display='none'">Close</button></th></tr>
//     </table></div>`;  

//     document.getElementById("infoDetailsFarmer").style.display = "block";
//     document.getElementById("infoDetailsFarmer").innerHTML = contentStringFarmer
//   }

//   const handleMarkerClickAIF = (marker1) => {
//     let contentStringAIF = `<div class="table-responsive imgthumbnails"><table class="table">
//     <tr><th>State  : &nbsp</th><td>${marker1.stateName}</td></tr>
//     <tr><th>District : &nbsp</th><td>${marker1.districtName}</td></tr>
//     <tr><th>Village : &nbsp</th><td>${marker1.villageName}</td></tr>
//     <tr><th>Project Name : &nbsp</th><td>${marker1.projectName}</td></tr>

//     <tr><th>Survey Date : &nbsp</th><td>${marker1.create_On.split("T")[0]}</td></tr>
   
//     <tr><th>Loan No. : &nbsp</th><td>${marker1.loanAppNo}</td></tr>
    

//     <tr><th>Scheme Name : &nbsp</th><td>Agri Infra Fund</td></tr>
//     <tr><th>Image :</th><td> <img alt="image" src=${marker1.aifImage} height="200px" width="300px"></img></td>
//     </tr>
//     <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsAIF').style.display='none'">Close</button></th></tr>
//     </table></div>`;  

//     document.getElementById("infoDetailsAIF").style.display = "block";
//     document.getElementById("infoDetailsAIF").innerHTML = contentStringAIF
//   }

//   const handleMarkerClickPDMC = (marker1) => {
//     let contentStringPDMC = `<div class="table-responsive imgthumbnails"><table class="table">
//     <tr><th>State  : &nbsp</th><td>${marker1.stateName}</td></tr>
//     <tr><th>District : &nbsp</th><td>${marker1.districtName}</td></tr>
//     <tr><th>Village : &nbsp</th><td>${marker1.villageName}</td></tr>


//     <tr><th>Scheme Name : &nbsp</th><td>${marker1.schemeName}</td></tr>
//     <tr><th>Farmer Name : &nbsp</th><td>${marker1.farmerName}</td></tr>
//     <tr><th>Caste Name : &nbsp</th><td>${marker1.casteCatName}</td></tr>
//     <tr><th>Scheme Name : &nbsp</th><td>PDMC</td></tr>


//     <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsPDMC').style.display='none'">Close</button></th></tr>
//     </table></div>`;  

//     document.getElementById("infoDetailsPDMC").style.display = "block";
//     document.getElementById("infoDetailsPDMC").innerHTML = contentStringPDMC
//   }

//   const handleMarkerClickNFSM = (marker) => {
     
//     let contentString = `<div class="table-responsive imgthumbnails">
//     <table class="table"><tr><th>Crop Demonstration Code :</th> <td> ${marker.cropDemonstrationCodeM}</td></tr>
//     <tr><th>Beneficiary Name : &nbsp</th><td>${marker.beneficiaryName}</td></tr>
//     <tr><th>Financial Year : &nbsp</th><td>${marker.finYear}</td></tr>
//     <tr><th>Crop : &nbsp</th><td>${marker.cropName}</td></tr>
//     <tr><th>Crop Variety : &nbsp</th><td>${marker.cropVarietyName}</td></tr>
//     <tr><th>Season : &nbsp</th><td>${marker.seasonName}</td></tr>
//     <tr><th>State : &nbsp</th><td>${marker.stateName}</td></tr>
//     <tr><th>District : &nbsp</th><td>${marker.districtName}</td></tr>
//     <tr><th>Village : &nbsp</th><td>${marker.villageName}</td></tr>
//     <tr><th>Scheme Name : &nbsp</th><td>NFSM</td></tr>
   
//     <tr><th>Image :</th><td> <img alt="image" src=https://nfsm.gov.in/nfsmapi1/${marker.landPhoto} height="200px" width="300px"></img></td>
//   </tr>
//   <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 NFSM" onclick="document.getElementById('infoDetails').style.display='none'">Close</button></th></tr>
//     </table>
//     </div>`;


//    document.getElementById("infoDetails").style.display = "block";
//    document.getElementById("infoDetails").innerHTML = contentString
//     setSelectedMarker(marker);
//   };

//   const handleMarkerClickNHB = (marker1) => {
//     let contentStringNHB = `<div class="table-responsive imgthumbnails"><table class="table">
//     <tr><th>State  : &nbsp</th><td>${marker1.stateName}</td></tr>
//     <tr><th>District : &nbsp</th><td>${marker1.districtName}</td></tr>
//     <tr><th>Village : &nbsp</th><td>${marker1.villageName}</td></tr>


//     <tr><th>Scheme Name : &nbsp</th><td>NHB - Inspection</td></tr>
//     <tr><th>Farmer Name : &nbsp</th><td>${marker1.farmerName}</td></tr>
//     <tr><th>Address : &nbsp</th><td>${marker1.address}</td></tr>
//     <tr><th>Caste Category : &nbsp</th><td>${marker1.casteCategory}</td></tr>
//     <tr><th>Survey Number : &nbsp</th><td>${marker1.surveyNo}</td></tr>
//     <tr><th>Scheme Name : &nbsp</th><td>NHB</td></tr>


//     <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsNHB').style.display='none'">Close</button></th></tr>
//     </table></div>`;  

//     document.getElementById("infoDetailsNHB").style.display = "block";
//     document.getElementById("infoDetailsNHB").innerHTML = contentStringNHB
//   }




const handleMarkerClickACABC = (marker) => {


  let contentString = ""

  console.log("acabcFilter", acabcFilter, typeof(acabcFilter))

  if(acabcFilter === "2") {

    let imageArray = marker.photo !== "" ? marker.photo.split(",") : "";

    console.log("imageArray!!!@@", imageArray)

    let filteredImageHtml = imageArray.map((item, index) => {
      return `<div class="carousel-item ${ index === 0 ? "active" : "" }"> <img src= ${"https://acabcmis.gov.in/acabcwebapi/" + item} class="d-block w-100" alt="..."/> </div>`;
  }).join('');
  
   document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;


    contentString = `<div class="table-responsive imgthumbnails">
    <button class="btn btn-close mapbtn" onclick="document.getElementById('infoDetailsACABC').style.display='none'"></button>
  <table class="table">
  <tr><th>Scheme Name : &nbsp</th><td>ACABC Agriventure</td></tr>
  <tr><th>Survey No. :</th> <td> ${marker.uIdentity}</td></tr>
  <tr><th>Surveyor Date: &nbsp</th><td>${marker.createdOn === null || marker.createdOn === "1900-01-01T00:00:00" ? "" : marker.createdOn.split("T")[0]}</td></tr>
  <tr><th>State: &nbsp</th><td>${marker.iState}</td></tr>
  <tr><th>District : &nbsp</th><td>${marker.districtName}</td></tr>
  <tr><th>Financial Year : &nbsp</th><td>${marker.finYear}</td></tr>
  <tr><th>Farmer Name : &nbsp</th><td>${marker.appName}</td></tr>
 
  <tr><th>Image :</th><td> <img alt="image" src=${marker.photo === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" : "https://acabcmis.gov.in/acabcwebapi/" + imageArray[0]} data-bs-toggle="modal" data-bs-target="#exampleModal"  height="150px" width="150px"></img></td></tr>
  <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 NFSM" onclick="document.getElementById('infoDetailsACABC').style.display='none'">Close</button></th></tr>
  </table>
  </div>`;

  }else {

    let imageArray = marker.photo !== "" ? marker.photo.split(",") : "";

    console.log("imageArray!!!", imageArray)

    let filteredImageHtml = imageArray.map((item, index) => {
      return `<div class="carousel-item ${ index === 0 ? "active" : "" }"> <img src= ${"https://acabcmis.gov.in/acabcwebapi/" + item} class="d-block w-100" alt="..."/> </div>`;
  }).join('');
  
   document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;

    contentString = `<div class="table-responsive imgthumbnails">
    <button class="btn btn-close mapbtn" onclick="document.getElementById('infoDetailsACABC').style.display='none'"></button>
  <table class="table">
  <tr><th>Scheme Name : &nbsp</th><td>ACABC Nodal Training Institute</td></tr>
  <tr><th>User Code :</th> <td> ${marker.userCode}</td></tr>
  <tr><th>Created Date: &nbsp</th><td>${marker.createdDate === null || marker.createdDate === "1900-01-01T00:00:00" ? "" : marker.createdDate.split("T")[0]}</td></tr>
  <tr><th>State: &nbsp</th><td>${marker.stateName}</td></tr>
  <tr><th>Officer Name: &nbsp</th><td>${marker.name}</td></tr> 
  <tr><th>Institute Name: &nbsp</th><td>${marker.instituteNM}</td></tr>


   <tr><th>Image :</th><td> <img alt="image" src=${marker.photo === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" : "https://acabcmis.gov.in/acabcwebapi/" + imageArray[0]} data-bs-toggle="modal" data-bs-target="#exampleModal"  height="150px" width="150px"></img></td></tr>
  <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 NFSM" onclick="document.getElementById('infoDetailsACABC').style.display='none'">Close</button></th></tr>
  </table>
  </div>`;

  }



document.getElementById("infoDetailsACABC").style.display = "block";
document.getElementById("infoDetailsACABC").innerHTML = contentString
// setSelectedMarker(marker);

const newPosition = {
  lat: parseFloat(marker.latitude),
  lng: parseFloat(marker.longitude),
};

map.panTo(newPosition);
map.setZoom(18);
 
}; 
const handleMarkerClickAgroforestry = (marker1) => {

  let base_url = process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE + "/api/common/GetAttachbyURL?imageURL=" : process.env.REACT_APP_PRO_MODE + "/api/common/GetAttachbyURL?imageURL=";
  let image_url = marker1.farmerCropSurveyImageList.length != 0 ? marker1.farmerCropSurveyImageList[0].attPath : "" 

  let filteredImageHtml = `<div class="carousel-item active"><img src= ${image_url === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" :  base_url + image_url} class="d-block w-100" alt="..."/></div>`
  document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;

  let contentStringAgro = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsAgroforestry').style.display='none'"></button>
  <table class="table">
  <tr><th>Scheme Name : &nbsp</th><td>${marker1.schemeName}</td></tr>  

  <tr><th>Survey No. : &nbsp</th><td>${marker1.surveyNo}</td></tr>
  <tr><th>Survey Date : &nbsp</th><td>${marker1.createdOn === "" || marker1.createdOn === "1900-01-01T00:00:00" ? "" : marker1.createdOn.split("T")[0]}</td></tr>


  <tr><th>State  : &nbsp</th><td>${marker1.stateName}</td></tr>
  <tr><th>District : &nbsp</th><td>${marker1.districtName}</td></tr>
  <tr><th>Sub District : &nbsp</th><td>${marker1.subDistrictName}</td></tr>
  <tr><th>Block : &nbsp</th><td>${marker1.blockName}</td></tr>
  <tr><th>Village : &nbsp</th><td>${marker1.villageName}</td></tr>

  <tr><th>Beneficiary Name : &nbsp</th><td>${marker1.beneficiaryName}</td></tr>
  <tr><th>Project Name : &nbsp</th><td>${marker1.projectName}</td></tr>


  <tr><th>Image :</th><td> <img alt="image" src= ${image_url === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" :  base_url + image_url} data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></img></td></tr>
  <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsAgroforestry').style.display='none'">Close</button></th></tr>
  </table></div>`;  

  document.getElementById("infoDetailsAgroforestry").style.display = "block";
  document.getElementById("infoDetailsAgroforestry").innerHTML = contentStringAgro

  const newPosition = {
    lat: parseFloat(marker1.farmerCropSurveyPolygonList[0].surveyorLat),
    lng: parseFloat(marker1.farmerCropSurveyPolygonList[0].surveyorLong),
  };
  
  map.panTo(newPosition);
  map.setZoom(18);
 
};
const handleMarkerClickAIF = (marker) => {

  let filteredImageHtml = marker.geoImages.map((item, index) => {
    return `<div class="carousel-item ${ index === 0 ? "active" : "" }"> <img src= ${item.aiF_Image_Name} class="d-block w-100" alt="..."/> </div>`;
}).join('');

 document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;
  
  let contentString = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsAIF').style.display='none'"></button>
  <table class="table">
  <tr><th>Scheme Name : &nbsp</th><td>Agriculture Infrastructure Fund </td></tr>
  <tr><th>Loan No. :</th> <td> ${marker.loanApplicationNo}</td></tr>
  <tr><th>Surveyor Date: &nbsp</th><td>${marker.project_Geo_Update_Date === null || marker.project_Geo_Update_Date === "1900-01-01T00:00:00" ? "" :  marker.project_Geo_Update_Date.split("T")[0]}</td></tr>
  <tr><th>State: &nbsp</th><td>${marker.stateName}</td></tr>
  <tr><th>District : &nbsp</th><td>${marker.districtName}</td></tr>
  <tr><th>Village : &nbsp</th><td>${marker.villageName}</td></tr>
  <tr><th>Project Name : &nbsp</th><td>${marker.projectName}</td></tr>
  <tr><th>Image :</th><td>
  <img src=${marker.geoImages[0].aiF_Image_Name} data-bs-toggle="modal" data-bs-target="#exampleModal" class="d-block w-100" alt="...">
  </td>
  </tr>
  <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 NFSM" onclick="document.getElementById('infoDetailsAIF').style.display='none'">Close</button></th></tr>
  </table>
  </div>`;
  
  
  document.getElementById("infoDetailsAIF").style.display = "block";
  document.getElementById("infoDetailsAIF").innerHTML = contentString
  // setSelectedMarker(marker);

  // <tr><th>Image :</th><td> <img alt="image" src=${marker.geoImages[0].aiF_Image_Name} height="200px" width="300px"></img></td>
  //  </tr>
  
  const newPosition = {
    lat: parseFloat(marker.geoImages[0].geoLatitude),
    lng: parseFloat(marker.geoImages[0].geoLongitude),
  };
  
  map.panTo(newPosition);
  map.setZoom(18);
 
};
const handleMarkerClickAMI = (marker) => {

  let filteredImageHtml = marker.geoImages.map((item, index) => {
    return `<div class="carousel-item ${ index === 0 ? "active" : "" }"> <img src= ${item.aiF_Image_Name} class="d-block w-100" alt="..."/> </div>`;
}).join('');

 document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;
  
  let contentString = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsAIF').style.display='none'"></button>
  <table class="table">
  <tr><th>Scheme Name : &nbsp</th><td>Agriculture Marketing Infrastructure</td></tr>
  <tr><th>Loan No. :</th> <td> ${marker.loanApplicationNo}</td></tr>
  <tr><th>Surveyor Date: &nbsp</th><td>${marker.project_Geo_Update_Date === null || marker.project_Geo_Update_Date === "1900-01-01T00:00:00" ? "" :  marker.project_Geo_Update_Date.split("T")[0]}</td></tr>
  <tr><th>State: &nbsp</th><td>${marker.stateName}</td></tr>
  <tr><th>District : &nbsp</th><td>${marker.districtName}</td></tr>
  <tr><th>Village : &nbsp</th><td>${marker.villageName}</td></tr>
  <tr><th>Project Name : &nbsp</th><td>${marker.projectName}</td></tr>
  <tr><th>Image :</th><td>
  <img src=${marker.geoImages[0].aiF_Image_Name} data-bs-toggle="modal" data-bs-target="#exampleModal" class="d-block w-100" alt="...">
  </td>
  </tr>
  <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 NFSM" onclick="document.getElementById('infoDetailsAIF').style.display='none'">Close</button></th></tr>
  </table>
  </div>`;
  
  
  document.getElementById("infoDetailsAIF").style.display = "block";
  document.getElementById("infoDetailsAIF").innerHTML = contentString
  // setSelectedMarker(marker);

  // <tr><th>Image :</th><td> <img alt="image" src=${marker.geoImages[0].aiF_Image_Name} height="200px" width="300px"></img></td>
  //  </tr>
  
  const newPosition = {
    lat: parseFloat(marker.geoImages[0].geoLatitude),
    lng: parseFloat(marker.geoImages[0].geoLongitude),
  };
  
  map.panTo(newPosition);
  map.setZoom(18);
 
};
const handleMarkerClickMANDT = (marker) => {


let filteredImageHtml = `<div class="carousel-item active"><img  src=${marker.chcCenterPhotoPath === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" :  mandtFilter === "1" ? "https://agrimachinery.nic.in/ChcApp" + marker.chcCenterPhotoPath :   marker.chcCenterPhotoPath} class="d-block w-100" alt="..."/></div>`
   document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;

  let dateLabel = "";
  if(mandtFilter === "1") {
    dateLabel = marker.registraionDate
  }else {
    dateLabel = marker.addedDate
  }
 
let contentString = `<div class="table-responsive imgthumbnails">
<button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsMANDT').style.display='none'"></button>
<table class="table">
<tr><th>Scheme Name : &nbsp</th><td>M&T-CHC</td></tr>
<tr><th>CHC Id :</th> <td> ${ mandtFilter === "1" ? marker.loginID : marker.chcUserId}</td></tr>
<tr><th>Added Date: &nbsp</th><td>${dateLabel === "" ||  dateLabel === "1900-01-01T00:00:00" ? "" : dateLabel.split("T")[0]}</td></tr>
<tr><th>State: &nbsp</th><td>${marker.stateName}</td></tr>
<tr><th>District : &nbsp</th><td>${marker.districtName}</td></tr>
<tr><th>Subdistrict : &nbsp</th><td>${marker.subDistrictName}</td></tr>
<tr><th>Block: &nbsp</th><td>${marker.blockName}</td></tr>
<tr><th>Village: &nbsp</th><td>${marker.revenueVillageName}</td></tr>
<tr><th>CHC Name : &nbsp</th><td>${ mandtFilter === "1" ? marker.groupName : marker.shgName}</td></tr> 
<tr><th>Total no. of Implements: &nbsp</th><td id="openMandt" data-bs-toggle="modal" data-bs-target="#exampleModalMandT" ><span>${ mandtFilter === "1" ? marker.no_ImplementSubsidyID :  marker.noofImplementCount     }<span class="mntpop">View</span></span></td></tr> 
<tr><th>Image :</th><td> <img alt="image" src=${marker.chcCenterPhotoPath === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" :  mandtFilter === "1" ? "https://agrimachinery.nic.in/ChcApp" + marker.chcCenterPhotoPath :   marker.chcCenterPhotoPath} data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></img></td></tr>
<tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 NFSM" onclick="document.getElementById('infoDetailsMANDT').style.display='none'">Close</button></th></tr>
</table>
</div>`;


document.getElementById("infoDetailsMANDT").style.display = "block";
document.getElementById("infoDetailsMANDT").innerHTML = contentString

document.getElementById("openMandt").addEventListener("click", () => openMandtPopup(`${mandtFilter === "1" ? marker.loginID : marker.chcUserId}`));
// setSelectedMarker(marker);

const newPosition = {
  lat: parseFloat(marker.latitude),
  lng: parseFloat(marker.longitude),
};

map.panTo(newPosition);
map.setZoom(18);
};
const handleMarkerClickNBHM = (marker1, key) => {

  let filteredImageHtml = `<div class="carousel-item active"><img src= ${marker1.farmerCropSurveyImageList.length === 0 ? "https://krishimapper.dac.gov.in/imagenotfound.png" : process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE  + "/api/common/GetAttachbyURL?imageURL=" + marker1.farmerCropSurveyImageList[0].attPath : process.env.REACT_APP_PRO_MODE + "/api/common/GetAttachbyURL?imageURL=" + marker1.farmerCropSurveyImageList[0].attPath } class="d-block w-100" alt="..."/></div>`
   document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;


  let compName = "";
  if(key === "1") {
    compName = "Honey Processing Unit"
  }else if(key === "2") {
    compName = "Honey Testing Unit"
  }else if(key === "3") {
    compName = "Honey CHC"
  }else {
    compName = "Beeflora Plantation"
  }
  console.log("marker1@@", marker1)
  console.log("marker1.farmerCropSurveyImageList", marker1.farmerCropSurveyImageList,  marker1.farmerCropSurveyImageList == [])
  let contentStringNBHM = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsNBHM').style.display='none'"></button>
  <table class="table">
      <tr><th>Scheme Name : &nbsp</th><td>${marker1.schemeName}</td></tr>
      <tr><th>Component Name : &nbsp</th><td>${compName}</td></tr>  

      <tr><th>Survey No. : &nbsp</th><td>${marker1.surveyNo}</td></tr>
      <tr><th>Survey Date : &nbsp</th><td>${marker1.createdOn === null || marker1.createdOn === "1900-01-01T00:00:00" ? "" : marker1.createdOn.split("T")[0]}</td></tr>


      <tr><th>State  : &nbsp</th><td>${marker1.stateName}</td></tr>
      <tr><th>District : &nbsp</th><td>${marker1.districtName}</td></tr>
      <tr><th>Sub District : &nbsp</th><td>${marker1.subDistrictName}</td></tr>
      <tr><th>Block : &nbsp</th><td>${marker1.blockName}</td></tr>
      <tr><th>Village : &nbsp</th><td>${marker1.villageName}</td></tr>
     
      <tr><th>Farmer Name : &nbsp</th><td>${marker1.farmerName ? marker1.farmerName : marker1.beneficiaryName}</td></tr>
      
  
      <tr><th>Image :</th><td> <img alt="image" src= ${marker1.farmerCropSurveyImageList.length === 0 ? "https://krishimapper.dac.gov.in/imagenotfound.png" : process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE  + "/api/common/GetAttachbyURL?imageURL=" + marker1.farmerCropSurveyImageList[0].attPath : process.env.REACT_APP_PRO_MODE + "/api/common/GetAttachbyURL?imageURL=" + marker1.farmerCropSurveyImageList[0].attPath } data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></img></td></tr>
      <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsNBHM').style.display='none'">Close</button></th></tr>
      </table></div>`;  
  
      document.getElementById("infoDetailsNBHM").style.display = "block";
      document.getElementById("infoDetailsNBHM").innerHTML = contentStringNBHM

      const newPosition = {
        lat: parseFloat(marker1.farmerCropSurveyPolygonList[0].surveyorLat),
        lng: parseFloat(marker1.farmerCropSurveyPolygonList[0].surveyorLong),
      };
      
      map.panTo(newPosition);
      map.setZoom(18);
 
};
const handleMarkerClickNFSM = (marker) => {

  console.log("cropStatephot", marker.cropStatePhoto)

  let ImageHTML = `<div class="carousel-item active"><img src= ${marker.landPhoto === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" : `https://nfsm.gov.in/nfsmapi1/${marker.landPhoto}`} class="d-block w-100" alt="..."/></div>`


    
  
    if(marker.cropStatePhoto != null) {
      let localImageArray = marker.cropStatePhoto.split(",");
      console.log("localImageArray", localImageArray)
     

    //   let filteredImageHtml = localImageArray.map((item, index) => {
    //     return `<div class="carousel-item ${ index === 0 ? "active" : "" }"> <img src= ${item[]} class="d-block w-100" alt="..."/> </div>`;
    // }).join('');

    for(let i=0; i< localImageArray.length; i++) {
      ImageHTML = ImageHTML + `<div class="carousel-item"> <img src= 'https://nfsm.gov.in/nfsmapi1/${localImageArray[i]}' class="d-block w-100" alt="..."/> </div>`;

    }

    }else {

    }

    console.log("ImageHTML", ImageHTML)
  





  document.getElementById("AIFImageSlider").innerHTML = ImageHTML;

  let sowingDateLocal = "";
  console.log("sowingDate", marker.sowingDate)
  if(marker.sowingDate) {
    sowingDateLocal =  marker.sowingDate.split(" ")[0]
  }else {
    sowingDateLocal = ""
  }

      let contentString = `<div class="table-responsive imgthumbnails">
      <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsNFSM').style.display='none'"></button>
    <table class="table">
    <tr><th>Scheme Name : &nbsp</th><td>NFSM</td></tr> 
    <tr><th>Survey Date : &nbsp</th><td>${sowingDateLocal === null || sowingDateLocal === "1900-01-01T00:00:00" ? "" : sowingDateLocal}</td></tr>
    <tr><th>State : &nbsp</th><td>${marker.stateName}</td></tr>
    <tr><th>District : &nbsp</th><td>${marker.districtName}</td></tr>
    <tr><th>Village : &nbsp</th><td>${marker.villageName}</td></tr>
    <tr><th>Crop Demonstration Code :</th> <td> ${marker.cropDemonstrationCodeM}</td></tr>
    <tr><th>Financial Year : &nbsp</th><td>${marker.finYear}</td></tr>
    <tr><th>Crop Name: &nbsp</th><td>${marker.cropName}</td></tr>
    <tr><th>Crop Variety : &nbsp</th><td>${marker.cropVarietyName}</td></tr>
    <tr><th>Season : &nbsp</th><td>${marker.seasonName}</td></tr>


    <tr><th>Beneficiary Name : &nbsp</th><td>${marker.beneficiaryName}</td></tr>
   
    <tr><th>Image :</th><td> <img alt="image" src= ${marker.landPhoto === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" : `https://nfsm.gov.in/nfsmapi1/${marker.landPhoto}`} data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></img></td>
  </tr>
  <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 NFSM" onclick="document.getElementById('infoDetailsNFSM').style.display='none'">Close</button></th></tr>
    </table>
    </div>`;


   document.getElementById("infoDetailsNFSM").style.display = "block";
   document.getElementById("infoDetailsNFSM").innerHTML = contentString

   const newPosition = {
    lat: parseFloat(marker.latitude),
    lng: parseFloat(marker.longitude),
  };
  
  map.panTo(newPosition);
  map.setZoom(18);
 
};
const handleMarkerClickNHB = (marker) => {

  let filteredImageHtml = marker.polygons.map((item, index) => {
    return `<div class="carousel-item ${ index === 0 ? "active" : "" }"> ${item.source.includes(".mp4")  ? '<video controls src= '+ item.source +' />'  : '<img src= '+item.source+' class="d-block w-100" alt="..."/>' } </div>`;
}).join('');

   document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;


  let contentString = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsNHB').style.display='none'"></button>
  <table class="table">
  <tr><th>Scheme Name : &nbsp</th><td>NHB-Inspection</td></tr> 
  <tr><th>Survey No. : &nbsp</th><td>${marker.surveyNo}</td></tr>
  <tr><th>State : &nbsp</th><td>${marker.stateName}</td></tr>
  <tr><th>District : &nbsp</th><td>${marker.districtName}</td></tr>
  <tr><th>Village : &nbsp</th><td>${marker.villageName}</td></tr>
  <tr><th>Farmer Name: &nbsp</th><td>${marker.farmerName}</td></tr>


  <tr><th>Beneficiary Name : &nbsp</th><td>${marker.beneficiaryName}</td></tr>
 
  <tr><th>Image :</th><td> <img alt="image" src= ${marker.polygons[0].source.length === 0 ? "https://krishimapper.dac.gov.in/imagenotfound.png" : marker.polygons[0].source} data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></img></td>
</tr>
<tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 NFSM" onclick="document.getElementById('infoDetailsNHB').style.display='none'">Close</button></th></tr>
  </table>
  </div>`;


 document.getElementById("infoDetailsNHB").style.display = "block";
 document.getElementById("infoDetailsNHB").innerHTML = contentString

 const newPosition = {
  lat: parseFloat(marker.polygons[0].lat),
  lng: parseFloat(marker.polygons[0].lng),
};

map.panTo(newPosition);
map.setZoom(18);
 
};
const handleMarkerClickNMEO = (marker1) => {
  let contentStringNMEO = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsNMEO').style.display='none'"></button>
  <table class="table">
  <tr><th>Scheme Name : &nbsp</th><td>${marker1.schemeName}</td></tr>  

  <tr><th>Survey No. : &nbsp</th><td>${marker1.surveyNo}</td></tr>
  <tr><th>Survey Date : &nbsp</th><td>${marker1.createdOn === null || marker1.createdOn === "1900-01-01T00:00:00" ? "" :  marker1.createdOn.split("T")[0]}</td></tr>


  <tr><th>State  : &nbsp</th><td>${marker1.stateName}</td></tr>
  <tr><th>District : &nbsp</th><td>${marker1.districtName}</td></tr>
  <tr><th>Sub District : &nbsp</th><td>${marker1.subDistrictName}</td></tr>
  <tr><th>Block : &nbsp</th><td>${marker1.blockName}</td></tr>
  <tr><th>Village : &nbsp</th><td>${marker1.villageName}</td></tr>
  <tr><th>Financial Year : &nbsp</th><td>${marker1.farmerCropDetailsExtsList[0].finYear}</td></tr>

  <tr><th>Crop Name : &nbsp</th><td>${marker1.farmerCropDetailsExtsList[0].cropName}</td></tr>
  <tr><th>Crop Variety : &nbsp</th><td>${marker1.farmerCropDetailsExtsList[0].cropVarietyName}</td></tr>
  <tr><th>Season : &nbsp</th><td>${marker1.farmerCropDetailsExtsList[0].seasonName}</td></tr>
  <tr><th>Farmer Name : &nbsp</th><td>${marker1.farmerName}</td></tr>
  <tr><th>Activity Name : &nbsp</th><td>${marker1.activityType}</td></tr> 

  <tr><th>Image :</th><td> <img alt="image" src= ${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE  + "/api/common/GetAttachbyURL?imageURL=" + marker1.farmerCropSurveyImageList[0].attPath : process.env.REACT_APP_PRO_MODE + "/api/common/GetAttachbyURL?imageURL=" + marker1.farmerCropSurveyImageList[0].attPath } height="150px" width="150px"></img></td></tr>
  <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsNMEO').style.display='none'">Close</button></th></tr>
  </table></div>`;  

  document.getElementById("infoDetailsNMEO").style.display = "block";
  document.getElementById("infoDetailsNMEO").innerHTML = contentStringNMEO

  const newPosition = {
    lat: parseFloat(marker1.farmerCropSurveyPolygonList[0].surveyorLat),
    lng: parseFloat(marker1.farmerCropSurveyPolygonList[0].surveyorLong),
  };
  
  map.panTo(newPosition);
  map.setZoom(18);
 
};
const handleMarkerClickPDMC = (marker1) => {

  console.log("marker1", marker1);
  console.log("marker1", marker1.farmerCropSurveyImageList != [])

  let base_url = process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE + "/api/common/GetAttachbyURL?imageURL=" : process.env.REACT_APP_PRO_MODE + "/api/common/GetAttachbyURL?imageURL=";
  let image_url = marker1.farmerCropSurveyImageList.length != 0 ? marker1.farmerCropSurveyImageList[0].attPath : "" 

  let filteredImageHtml = `<div class="carousel-item active"><img src= ${image_url === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" :  base_url + image_url} class="d-block w-100" alt="..."/></div>`
  document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;

  let contentStringPDMC = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsPDMC').style.display='none'"></button>
  <table class="table">
  <tr><th>Scheme Name : &nbsp</th><td>${marker1.schemeName}</td></tr>  

  <tr><th>Survey No. : &nbsp</th><td>${marker1.surveyNo}</td></tr>
  <tr><th>Survey Date : &nbsp</th><td>${marker1.createdOn === null || marker1.createdOn === "1900-01-01T00:00:00"  ? "" : marker1.createdOn.split("T")[0]}</td></tr>


  <tr><th>State  : &nbsp</th><td>${marker1.stateName}</td></tr>
  <tr><th>District : &nbsp</th><td>${marker1.districtName}</td></tr>
  <tr><th>Sub District : &nbsp</th><td>${marker1.subDistrictName}</td></tr>
  <tr><th>Block : &nbsp</th><td>${marker1.blockName}</td></tr>
  <tr><th>Village : &nbsp</th><td>${marker1.villageName}</td></tr>
  <tr><th>Financial Year : &nbsp</th><td>${marker1.farmerCropDetailsExtsList[0].finYear}</td></tr>

  <tr><th>Crop Name : &nbsp</th><td>${marker1.farmerCropDetailsExtsList[0].cropName}</td></tr>
  <tr><th>Crop Variety : &nbsp</th><td>${marker1.farmerCropDetailsExtsList[0].cropVarietyName}</td></tr>
  <tr><th>Season : &nbsp</th><td>${marker1.farmerCropDetailsExtsList[0].seasonName}</td></tr>
  <tr><th>Farmer Name : &nbsp</th><td>${marker1.farmerName}</td></tr>
  <tr><th>Activity Name : &nbsp</th><td>${marker1.activityType}</td></tr> 

  <tr><th>Image :</th><td> <img alt="image" src= ${image_url === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" :  base_url + image_url} data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></img></td></tr>
  <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsPDMC').style.display='none'">Close</button></th></tr>
  </table></div>`;  

  document.getElementById("infoDetailsPDMC").style.display = "block";
  document.getElementById("infoDetailsPDMC").innerHTML = contentStringPDMC

  const newPosition = {
    lat: parseFloat(marker1.farmerCropSurveyPolygonList[0].surveyorLat),
    lng: parseFloat(marker1.farmerCropSurveyPolygonList[0].surveyorLong),
  };
  
  map.panTo(newPosition);
  map.setZoom(18);
 
};
const handleMarkerClickRAD = (marker1) => {

  let filteredImageHtml = `<div class="carousel-item active"><img src= ${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE  + "/api/common/GetAttachbyURL?imageURL=" + marker1.farmerCropSurveyImageList[0].attPath : process.env.REACT_APP_PRO_MODE + "/api/common/GetAttachbyURL?imageURL=" + marker1.farmerCropSurveyImageList[0].attPath } class="d-block w-100" alt="..."/></div>`
   document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;

  let contentStringRAD = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsRAD').style.display='none'"></button>
  <table class="table">
  <tr><th>Scheme Name : &nbsp</th><td>${marker1.schemeName}</td></tr>  

  <tr><th>Survey No. : &nbsp</th><td>${marker1.surveyNo}</td></tr>
  <tr><th>Survey Date : &nbsp</th><td>${marker1.createdOn === null || marker1.createdOn === "1900-01-01T00:00:00"  ? "" : marker1.createdOn.split("T")[0]}</td></tr>


  <tr><th>State  : &nbsp</th><td>${marker1.stateName}</td></tr>
  <tr><th>District : &nbsp</th><td>${marker1.districtName}</td></tr>
  <tr><th>Sub District : &nbsp</th><td>${marker1.subDistrictName}</td></tr>
  <tr><th>Block : &nbsp</th><td>${marker1.blockName}</td></tr>
  <tr><th>Village : &nbsp</th><td>${marker1.villageName}</td></tr>
  <tr><th>Financial Year : &nbsp</th><td>${marker1.farmerCropDetailsExtsList[0].finYear}</td></tr>

  <tr><th>Crop Name : &nbsp</th><td>${marker1.farmerCropDetailsExtsList[0].cropName}</td></tr>
  <tr><th>Crop Variety : &nbsp</th><td>${marker1.farmerCropDetailsExtsList[0].cropVarietyName}</td></tr>
  <tr><th>Season : &nbsp</th><td>${marker1.farmerCropDetailsExtsList[0].seasonName}</td></tr>
  <tr><th>Farmer Name : &nbsp</th><td>${marker1.farmerName}</td></tr>
  <tr><th>Activity Name : &nbsp</th><td>${marker1.activityType}</td></tr> 
  <tr><th>Image :</th><td> <img alt="image" src= ${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE  + "/api/common/GetAttachbyURL?imageURL=" + marker1.farmerCropSurveyImageList[0].attPath : process.env.REACT_APP_PRO_MODE + "/api/common/GetAttachbyURL?imageURL=" + marker1.farmerCropSurveyImageList[0].attPath } data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></img></td></tr>
  <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsRAD').style.display='none'">Close</button></th></tr>
  </table></div>`;  

  document.getElementById("infoDetailsRAD").style.display = "block";
  document.getElementById("infoDetailsRAD").innerHTML = contentStringRAD

  const newPosition = {
    lat: parseFloat(marker1.farmerCropSurveyPolygonList[0].surveyorLat),
    lng: parseFloat(marker1.farmerCropSurveyPolygonList[0].surveyorLong),
  };
  
  map.panTo(newPosition);
  map.setZoom(18);
 
};
const handleMarkerClickSHCFarmer = async (data) => {

  const resultSHCFarmerInfo = await SHCFarmerInfoFetchData(String(data.farmerId));
  

  console.log("resultSHCFarmerInfo", resultSHCFarmerInfo)

  if(resultSHCFarmerInfo.data.data) {
    let marker1 = resultSHCFarmerInfo.data.data[0]
    
    let filteredImageHtml = marker1.plotImage.map((item, index) => {
      return `<div class="carousel-item ${ index === 0 ? "active" : "" }"> '<img src= ' ${ process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE  + "/Images/GetSHCImages/" + marker1.stateCode + "/" + marker1.districtCode + "/" + marker1.plotImage[0].image : process.env.REACT_APP_PRO_MODE + "/Images/GetSHCImages/" + marker1.stateCode + "/" + marker1.districtCode + "/" + marker1.plotImage[0].image} ' class="d-block w-100" id="image" alt="..."/>' </div>`;
  }).join('');
  
     document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;


   
    console.log("marker1", marker1)

    let fertilizerRecommendationValue = ""

    if(marker1.fertilizerRecommendation.length === 0) {
      fertilizerRecommendationValue = "NA"
    }else {
      marker1.fertilizerRecommendation.map((item, index) => {
        fertilizerRecommendationValue =  fertilizerRecommendationValue + item.fertilizerName + ","
      }) 

      

   
    }

  let contentStringFarmer = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsSHCFarmer').style.display='none'"></button>
  <table class="table">
  <tr><th>Scheme Name  : &nbsp</th><td>SHC-Farmer</td></tr>
  <tr><th>Survey No.  : &nbsp</th><td>${marker1.surveyNo}</td></tr>
<tr><th>State  : &nbsp</th><td>${marker1.stateName}</td></tr>
<tr><th>District : &nbsp</th><td>${marker1.districtName}</td></tr>
<tr><th>Village : &nbsp</th><td>${marker1.villageName}</td></tr>
<tr><th>Farmer Name : &nbsp</th><td>${marker1.farmerName}</td></tr>
<tr><th>Farmer Address : &nbsp</th><td>${marker1.farmerAddress}</td></tr>
<tr><th>Soil Color : &nbsp</th><td>${marker1.soilcolor ? marker1.soilcolor : "NA"}</td></tr>
<tr><th>Soil Texture : &nbsp</th><td>${marker1.soilTexture}</td></tr>
<tr><th>Soil Status : &nbsp</th><td>${marker1.soilStatus}</td></tr> 
<tr><th>Soil pH Value : &nbsp</th><td>${marker1.resultsPH.toFixed(2)}</td></tr>

<tr><th>Fertilizer Recommendation : &nbsp</th><td>${fertilizerRecommendationValue}</td></tr>


<tr><th>Image :</th><td> <img alt="image" src=   ${marker1.plotImage.length === 0 ? "https://krishimapper.dac.gov.in/imagenotfound.png" : marker1.plotImage[0].image ===  "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" : process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE  + "/Images/GetSHCImages/" + marker1.stateCode + "/" + marker1.districtCode + "/" + marker1.plotImage[0].image : process.env.REACT_APP_PRO_MODE + "/Images/GetSHCImages/" + marker1.stateCode + "/" + marker1.districtCode + "/" + marker1.plotImage[0].image} data-bs-toggle="modal" data-bs-target="#exampleModal" height="200px" width="300px"></img></td></tr>
<tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsSHCFarmer').style.display='none'">Close</button></th></tr>
</table></div>`;  

document.getElementById("infoDetailsSHCFarmer").style.display = "block";
document.getElementById("infoDetailsSHCFarmer").innerHTML = contentStringFarmer

var angle = 0,
img = document.getElementsByClassName('AIFImageSliderClass');
document.getElementById('button').onclick = function() {
angle = (angle + 90) % 360;
img.className = "rotate" + angle;
}

  }
 

  const newPosition = {
    lat: parseFloat(data.coordinatesLatitude),
    lng: parseFloat(data.coordinateslogitude),
  };
  
  map.panTo(newPosition);
  map.setZoom(18);
};
const handleMarkerClickSHCLab = (marker1) => {
  let contentStringSoilLab = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsSHCLab').style.display='none'"></button>
  <table class="table">
      <tr><th>Scheme Name : &nbsp</th><td>Soil Testing Lab</td></tr>
      <tr><th>Lab Id. : &nbsp</th><td>${marker1.stLid}</td></tr>

      <tr><th>Scheme Date : &nbsp</th><td>${marker1.createddate === null || marker1.createddate === "1900-01-01T00:00:00" ? "" :  marker1.createdate.split(" ")[0]}</td></tr>
      <tr><th>State  : &nbsp</th><td>${marker1.stateName}</td></tr> 
      <tr><th>District : &nbsp</th><td>${marker1.districtName}</td></tr>


    <tr><th> STL Name: &nbsp</th><td>${marker1.farmerName}</td></tr>
    <tr><th>STL Address: &nbsp</th><td>${marker1.farmerAddress}</td></tr>
    <tr><th>Lab Type: &nbsp</th><td>${marker1.labType}</td></tr>
    <tr><th>Lab Name : &nbsp</th><td>${marker1.testCenterName}</td></tr>
    <tr><th>Image :</th><td> <img alt="image" src= "https://krishimapper.dac.gov.in/imagenotfound.png" height="200px" width="300px"></img></td></tr>
    <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsSHCLab').style.display='none'">Close</button></th></tr>
    </table></div>`;  
    document.getElementById("infoDetailsSHCLab").style.display = "block";
    document.getElementById("infoDetailsSHCLab").innerHTML = contentStringSoilLab

    const newPosition = {
      lat: parseFloat(marker1.tcLatitude),
      lng: parseFloat(marker1.tcLongitude),
    };
    
    map.panTo(newPosition);
    map.setZoom(18);
 
};



const handleMarkerClickCropic = async (data) => {
  const resultCropicInfo = await CropicInfoFetchData(String(data.cropSurveyCode));
  

  if(resultCropicInfo.data.dataContent) {
    let marker1 = resultCropicInfo.data.dataContent[0]

  

 
  console.log("marker1", marker1.cropSurveyPolygonList[0].surveyorLat,  marker1.cropSurveyPolygonList[0].surveyorLong )

  // let activeMarkerLocal = new google.maps.LatLng(marker1.cropSurveyPolygonList[0].surveyorLat, marker1.cropSurveyPolygonList[0].surveyorLong);
  // // Draw a marker for each random point
  // let localMarker = new google.maps.Marker({
  //   position: activeMarkerLocal,
  //   map: map
  // });

  // console.log("localMarker", localMarker)

  let localMarker = {lat : marker1.cropSurveyPolygonList[0].surveyorLat, 
    long : marker1.cropSurveyPolygonList[0].surveyorLong  }

  // setActiveMarker(localMarker)
  setActiveMarkerPoint(localMarker)
  setActivePolygon(marker1.cropSurveyPolygonList[0].polygonShape)


  let filteredImageHtml = marker1.cropSurveyImageList.map((item, index) => {
    return `<div class="carousel-item ${ index === 0 ? "active" : "" }"> <img src= ${item.attPath} class="d-block w-100" alt="..."/> </div>`;
}).join('');

 document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;

  let contentStringCropic = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCropic').style.display='none'"></button>
  <table class="table">
  <tr><th>Scheme Name : &nbsp</th><td>Cropic</td></tr>
  <tr><th>Crop Survey Code : &nbsp</th><td>${marker1.surveyNo}</td></tr>
  <tr><th>Survey Date : &nbsp</th><td>${marker1.cropSurveyPolygonList[0].createModifyByIntUser.createdOnByUC === null || marker1.cropSurveyPolygonList[0].createModifyByIntUser.createdOnByUC ===  "1900-01-01T00:00:00" ? "" : marker1.cropSurveyPolygonList[0].createModifyByIntUser.createdOnByUC.split("T")[0]}</td></tr>
  <tr><th>State : &nbsp</th><td>${marker1.stateName}</td></tr>
  <tr><th>District : &nbsp</th><td>${marker1.districtName}</td></tr>
  <tr><th>Block : &nbsp</th><td>${marker1.blockName}</td></tr>
  <tr><th>Village : &nbsp</th><td>${marker1.villageName}</td></tr>


  <tr><th>Financial Year : &nbsp</th><td>${marker1.years}</td></tr>

  <tr><th>Crop Name : &nbsp</th><td>${marker1.cropName}</td></tr>
  <tr><th>Crop Category : &nbsp</th><td>${marker1.cropCategoryName}</td></tr>
  <tr><th>Season : &nbsp</th><td>${marker1.seasonName}</td></tr>
  <tr><th>Farmer Name : &nbsp</th><td>${marker1.farmerName}</td></tr>
  <tr><th>Insurance Company Name : &nbsp</th><td>${marker1.insuranceCompanyName}</td></tr> 

  <tr><th>Image :</th><td>
  <img src=${marker1.cropSurveyImageList.length === 0 ? "https://krishimapper.dac.gov.in/imagenotfound.png": marker1.cropSurveyImageList[0].attPath} data-bs-toggle="modal" data-bs-target="#exampleModal" class="d-block w-100" alt="..." height="150px" width="150px">
  </td>
  </tr>


<tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" id="closeCropic" >Close</button></th></tr>
</table></div>`;  
document.getElementById("infoDetailsCropic").style.display = "block";
document.getElementById("infoDetailsCropic").innerHTML = contentStringCropic


document.getElementById("closeCropic").addEventListener("click", closeActiveMarker);

  }

  const newPosition = {
    lat: parseFloat(data.surveyorLat),
    lng: parseFloat(data.surveyorLong),
  };
  
  map.panTo(newPosition);
  map.setZoom(18);

};

const handleMarkerClickRKVY = async (value) => {

  console.log("value$$", value)

 



  if(value.total) {

    const resultRKVYStateWise = await RKVYFetchDataStateWise(value);
    
    setRKVYData(resultRKVYStateWise.data.dataContent);


  }else {

    const fetchData = await RKVYInfoFetchData(value.id);
    let marker1 = fetchData.data.dataContent[0]
    

let filteredImageHtml = `<div class="carousel-item ${ marker1.photo1 === "" ? "" : "active" }"> <img src= ${marker1.photo1 === "" ? "" : marker1.photo1} class="d-block w-100" alt="..."/> </div> <div class="carousel-item"> <img src= ${marker1.photo2 === "" ? "" : marker1.photo2} class="d-block w-100" alt="..."/> </div>`;

   document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;

  let contentStringRKVY = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsRKVY').style.display='none'"></button>
  <table class="table">
      <tr><th>Scheme Name : &nbsp</th><td>Rashtriya Krishi Vikas Yojana </td></tr>
      <tr><th>Survey No. : &nbsp</th><td>${marker1.surveyNo}</td></tr> 
      <tr><th>Survey Date & Time : &nbsp</th><td>${marker1.date_time === null || marker1.date_time === "1900-01-01T00:00:00" ? "" : marker1.date_time}</td></tr>


      <tr><th>State  : &nbsp</th><td>${marker1.statename}</td></tr> 
      <tr><th>District : &nbsp</th><td>${marker1.distName}</td></tr>
      <tr><th>Block : &nbsp</th><td>${marker1.mandal}</td></tr>
      <tr><th>village : &nbsp</th><td>${marker1.village}</td></tr>

      <tr><th>Sector : &nbsp</th><td>${marker1.sector}</td></tr>
      <tr><th>Observer Name : &nbsp</th><td>${marker1.observername}</td></tr>
    
      <tr><th>Beneficiary Name : &nbsp</th><td>${marker1.benf_name}</td></tr> 
      <tr><th>Sub Sector : &nbsp</th><td>${marker1.subsector}</td></tr>
      <tr><th>Project Status : &nbsp</th><td>${marker1.projectstatus}</td></tr>


    <tr><th>Image :</th><td> <img alt="image" src=  ${marker1.photo1 === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" :  marker1.photo1} data-bs-toggle="modal" data-bs-target="#exampleModal" height="200px" width="300px"></img></td></tr>
    <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsRKVY').style.display='none'">Close</button></th></tr>
    </table></div>`;  
    document.getElementById("infoDetailsRKVY").style.display = "block";
    document.getElementById("infoDetailsRKVY").innerHTML = contentStringRKVY 

  }
 
};

const handleMarkerClickNaturalFarming = (marker1) => {
  let base_url = process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE + "/api/common/GetAttachbyURL?imageURL=" : process.env.REACT_APP_PRO_MODE + "/api/common/GetAttachbyURL?imageURL=";
  let image_url = marker1.farmerCropSurveyImage.length != 0 ? marker1.farmerCropSurveyImage[0].attPath : "" 

  let filteredImageHtml = `<div class="carousel-item active"><img src= ${image_url === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" :  base_url + image_url} class="d-block w-100" alt="..."/></div>`
  document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;

  let contentStringNaturalFarming = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsNaturalFarming').style.display='none'"></button>
  <table class="table">
  <tr><th>Scheme Name : &nbsp</th><td>Natural Farming</td></tr>  

  <tr><th>Survey No. : &nbsp</th><td>${marker1.surveyNo}</td></tr>
  <tr><th>Survey Date : &nbsp</th><td>${marker1.createdOn === "" || marker1.createdOn === "1900-01-01T00:00:00" ? "" : marker1.createdOn.split("T")[0]}</td></tr>


  <tr><th>State  : &nbsp</th><td>${marker1.stateName}</td></tr>
  <tr><th>District : &nbsp</th><td>${marker1.districtName}</td></tr>
  <tr><th>Sub District : &nbsp</th><td>${marker1.subDistrictName}</td></tr>
  <tr><th>Block : &nbsp</th><td>${marker1.blockName}</td></tr>
  <tr><th>Village : &nbsp</th><td>${marker1.villageName}</td></tr>
  <tr><th>Financial Year : &nbsp</th><td>${marker1.farmerCropDetails[0].finYear}</td></tr>

 
  <tr><th>Farmer Name : &nbsp</th><td>${marker1.farmerName}</td></tr>


  <tr><th>Image :</th><td> <img alt="image" src= ${image_url === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" :  base_url + image_url} data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></img></td></tr>
  <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsNaturalFarming').style.display='none'">Close</button></th></tr>
  </table></div>`;  

  document.getElementById("infoDetailsNaturalFarming").style.display = "block";
  document.getElementById("infoDetailsNaturalFarming").innerHTML = contentStringNaturalFarming
 
};

const handleMarkerClickMIDH = (marker1) => {
  let base_url = process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE + "/api/common/GetAttachbyURL?imageURL=" : process.env.REACT_APP_PRO_MODE + "/api/common/GetAttachbyURL?imageURL=";
  let image_url = marker1.farmerCropSurveyImageList.length != 0 ? marker1.farmerCropSurveyImageList[0].attPath : "" 

  let filteredImageHtml = `<div class="carousel-item active"><img src= ${image_url === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" :  base_url + image_url} class="d-block w-100" alt="..."/></div>`
   document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;

  let contentStringMIDH = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsMIDH').style.display='none'"></button>
  <table class="table">
  <tr><th>Scheme Name : &nbsp</th><td>Mission for Integrated Development of Horticulture</td></tr>  
  <tr><th>Component Name : &nbsp</th><td>${marker1.componentName}</td></tr>
  <tr><th>Survey No. : &nbsp</th><td>${marker1.surveyNo}</td></tr>
  <tr><th>Survey Date : &nbsp</th><td>${marker1.createdOn === "" || marker1.createdOn === "1900-01-01T00:00:00" ? "" : marker1.createdOn.split("T")[0]}</td></tr>
  <tr><th>State  : &nbsp</th><td>${marker1.stateName}</td></tr>
  <tr><th>District : &nbsp</th><td>${marker1.districtName}</td></tr>
  <tr><th>Sub District : &nbsp</th><td>${marker1.subDistrictName}</td></tr>
  <tr><th>Block : &nbsp</th><td>${marker1.blockName ? marker1.blockName : "NA" }</td></tr>
  <tr><th>Village : &nbsp</th><td>${marker1.villageName}</td></tr>
  <tr><th>Financial Year : &nbsp</th><td>${marker1.finYear}</td></tr>
  <tr><th>Farmer Name : &nbsp</th><td>${marker1.farmerName}</td></tr>
  <tr><th>Image :</th><td> <img alt="image" src= ${image_url === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" :  base_url + image_url} data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></img></td></tr>
  <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsMIDH').style.display='none'">Close</button></th></tr>
  </table></div>`;  

  document.getElementById("infoDetailsMIDH").style.display = "block";
  document.getElementById("infoDetailsMIDH").innerHTML = contentStringMIDH
 
};

const handleMarkerClickMOVCD = (marker1) => {
  let base_url = process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE + "/api/common/GetAttachbyURL?imageURL=" : process.env.REACT_APP_PRO_MODE + "/api/common/GetAttachbyURL?imageURL=";
  let image_url = marker1.farmerCropSurveyImageList.length != 0 ? marker1.farmerCropSurveyImageList[0].attPath : "" 

  let filteredImageHtml = `<div class="carousel-item active"><img src= ${image_url === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" :  base_url + image_url} class="d-block w-100" alt="..."/></div>`
   document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;


  let contentStringMOVCD = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsMOVCD').style.display='none'"></button>
  <table class="table">
  <tr><th>Scheme Name : &nbsp</th><td>Mission Organic Value Chain Development</td></tr>  
  <tr><th>Survey No. : &nbsp</th><td>${marker1.surveyNo}</td></tr>
  <tr><th>Survey Date : &nbsp</th><td>${marker1.createdOn === "" || marker1.createdOn === "1900-01-01T00:00:00" ? "" : marker1.createdOn.split("T")[0]}</td></tr>
  <tr><th>State  : &nbsp</th><td>${marker1.stateName}</td></tr>
  <tr><th>District : &nbsp</th><td>${marker1.districtName}</td></tr>
  <tr><th>Sub District : &nbsp</th><td>${marker1.subDistrictName}</td></tr>
  <tr><th>Block : &nbsp</th><td>${marker1.blockName}</td></tr>
  <tr><th>Village : &nbsp</th><td>${marker1.villageName}</td></tr>
  <tr><th>Financial Year : &nbsp</th><td>${marker1.farmerCropDetailsExtsList[0].finYear}</td></tr>
  <tr><th>Farmer Name : &nbsp</th><td>${marker1.farmerName}</td></tr>
  <tr><th>Image :</th><td> <img alt="image" src= ${image_url === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" :  base_url + image_url} data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></img></td></tr>
  <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsMOVCD').style.display='none'">Close</button></th></tr>
  </table></div>`;  

  document.getElementById("infoDetailsMOVCD").style.display = "block";
  document.getElementById("infoDetailsMOVCD").innerHTML = contentStringMOVCD
 
};

const handleMarkerClickNPSS = (marker1) => {
 
  let contentStringNPSS = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsNPSS').style.display='none'"></button>
  <table class="table">
  <tr><th>Scheme Name : &nbsp</th><td>National Pest Surveillance System</td></tr>  
  <tr><th>Survey Date : &nbsp</th><td>${marker1.date === "" || marker1.date === "1900-01-01T00:00:00" ? "NA" : marker1.date}</td></tr>
  <tr><th>State  : &nbsp</th><td>${marker1.state}</td></tr>
  <tr><th>District : &nbsp</th><td>${marker1.district}</td></tr>
  <tr><th>Sub District : &nbsp</th><td>${marker1.subDistrict}</td></tr>
  <tr><th>Village : &nbsp</th><td>${marker1.village}</td></tr>
  <tr><th>Crop  : &nbsp</th><td>${marker1.crop}</td></tr>
  <tr><th>Pest : &nbsp</th><td>${marker1.pest}</td></tr>
  <tr><th>Pest Type : &nbsp</th><td>${marker1.pestType}</td></tr>
  <tr><th>ETL Value Red : &nbsp</th><td>${marker1.etlValueRed}</td></tr>
  <tr><th>ETL Value Yellow : &nbsp</th><td>${marker1.etlValueYellow}</td></tr>
<tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsNPSS').style.display='none'">Close</button></th></tr>
  </table></div>`;  
  document.getElementById("infoDetailsNPSS").style.display = "block";
  document.getElementById("infoDetailsNPSS").innerHTML = contentStringNPSS
 
};

const handleMarkerClickCotton = (marker1) => {



  let filteredImageHtml = `<div class="carousel-item active"><img src= ${marker1.farmer_image === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" : marker1.farmer_image } class="d-block w-100" alt="..."/></div>`
  if(marker1.land_photo !== "") {
    filteredImageHtml = filteredImageHtml + `<div class="carousel-item "><img src= ${marker1.land_photo} class="d-block w-100" alt="..."/></div>`
  }
   document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;

  let contentStringCotton = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCotton').style.display='none'"></button>
  <table class="table">
  <tr><th>Scheme Name : &nbsp</th><td>NFSM-NDPS Cotton</td></tr>  
  <tr><th>State  : &nbsp</th><td>${marker1.stateName}</td></tr>
  <tr><th>District : &nbsp</th><td>${marker1.districtName}</td></tr>
  <tr><th>Block : &nbsp</th><td>${marker1.blockName !== "" ? marker1.blockName : "NA" }</td></tr>
  <tr><th>Village : &nbsp</th><td>${marker1.villageName}</td></tr>

  <tr><th>Farmer Name : &nbsp</th><td>${marker1.farmer_name}</td></tr>
  <tr><th>Farmer Address : &nbsp</th><td>${marker1.farmer_address}</td></tr>
  <tr><th>Tech Name : &nbsp</th><td>${marker1.tech_name}</td></tr>     
  <tr><th>Total Land Area (Ha) : &nbsp</th><td>${marker1.total_land_area}</td></tr> 
  <tr><th>Total Cotton Area (Ha) : &nbsp</th><td>${marker1.land_area_cotton}</td></tr> 

  <tr><th>Image :</th><td> <img alt="image" src= ${marker1.farmer_image === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" : marker1.farmer_image } data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></img></td></tr>
  <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsCotton').style.display='none'">Close</button></th></tr>
  </table></div>`;  

  document.getElementById("infoDetailsCotton").style.display = "block";
  document.getElementById("infoDetailsCotton").innerHTML = contentStringCotton
 
};

const handleMarkerClickSeedHub = async (value) => {

  console.log("value$$", value)
  if(value.total) {

    const resultSeedHubLatLongDetails = await FetchSeedHubLatLongDetails(value);
    
    setSeedHubData(resultSeedHubLatLongDetails.data.dataContent);
    console.log("data$$", resultSeedHubLatLongDetails.data.dataContent)

  }else {
    console.log("value_detail$$", value.id)
    const fetchData = await FetchSeedHubDetailIdWise(value.id);
    let marker1 = fetchData.data.dataContent[0]
    

// let filteredImageHtml = `<div class="carousel-item ${ marker1.photo1 === "" ? "" : "active" }"> <img src= ${marker1.photo1 === "" ? "" : marker1.photo1} class="d-block w-100" alt="..."/> </div> <div class="carousel-item"> <img src= ${marker1.photo2 === "" ? "" : marker1.photo2} class="d-block w-100" alt="..."/> </div>`;

//    document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;

  let contentStringSeedHub = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsSeedHub').style.display='none'"></button>
  <table class="table">
  <tr><th>Scheme Name : &nbsp</th><td>Seed Hub</td></tr> 
  <tr><th>Session : &nbsp</th><td>${marker1.session_Year}</td></tr> 
  <tr><th>State  : &nbsp</th><td>${marker1.stateName}</td></tr> 
  <tr><th>District  : &nbsp</th><td>${marker1.districtName}</td></tr> 
  <tr><th>Block : &nbsp</th><td>${marker1.blockName}</td></tr> 
  <tr><th>Village : &nbsp</th><td>${marker1.villageName}</td></tr> 
  <tr><th>Season : &nbsp</th><td>${marker1.season}</td></tr> 
  <tr><th>Crop Code : &nbsp</th><td>${marker1.cropRegisteryIdentifier}</td></tr> 
  <tr><th>Crop Name : &nbsp</th><td>${marker1.cropName}</td></tr> 
  <tr><th>Registered Area (HA) : &nbsp</th><td>${marker1.registeredArea}</td></tr> 
  <tr><th>Inspection Area (HA) : &nbsp</th><td>${marker1.inspectionArea}</td></tr> 
  <tr><th>Certified Area (HA) : &nbsp</th><td>${marker1.certifiedArea}</td></tr> 
         
    <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsSeedHub').style.display='none'">Close</button></th></tr>
    </table></div>`;  
    document.getElementById("infoDetailsSeedHub").style.display = "block";
    document.getElementById("infoDetailsSeedHub").innerHTML = contentStringSeedHub 

  }
 
};

const handleMarkerClickCDB = (marker1) => {
  let base_url = process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE + "/api/common/GetAttachbyURL?imageURL=" : process.env.REACT_APP_PRO_MODE + "/api/common/GetAttachbyURL?imageURL=";
  let image_url = marker1.farmerCropSurveyImageList.length != 0 ? marker1.farmerCropSurveyImageList[0].attPath : "" 

  let filteredImageHtml = `<div class="carousel-item active"><img src= ${image_url === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" :  base_url + image_url} class="d-block w-100" alt="..."/></div>`
   document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;


  let contentStringCDB = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsCDB').style.display='none'"></button>
  <table class="table">
  <tr><th>Scheme Name : &nbsp</th><td>CDB (Cocunut Development Board)</td></tr> 
  <tr><th>Component Name : &nbsp</th><td>${marker1.componentName}</td></tr>
  <tr><th>Survey No. : &nbsp</th><td>${marker1.surveyNo}</td></tr>
  <tr><th>Survey Date : &nbsp</th><td>${marker1.createdOn === "" || marker1.createdOn === "1900-01-01T00:00:00" ? "" : marker1.createdOn.split("T")[0]}</td></tr>
  <tr><th>State  : &nbsp</th><td>${marker1.stateName}</td></tr>
  <tr><th>District : &nbsp</th><td>${marker1.districtName}</td></tr>
  <tr><th>Sub District : &nbsp</th><td>${marker1.subDistrictName}</td></tr>
  <tr><th>Village : &nbsp</th><td>${marker1.villageName}</td></tr>
  <tr><th>Image :</th><td> <img alt="image" src= ${image_url === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" :  base_url + image_url} data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></img></td></tr>
  <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsCDB').style.display='none'">Close</button></th></tr>
  </table></div>`;  

  document.getElementById("infoDetailsCDB").style.display = "block";
  document.getElementById("infoDetailsCDB").innerHTML = contentStringCDB
 
};

const handleMarkerClickDASD = (marker1) => {
  let base_url = process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE + "/api/common/GetAttachbyURL?imageURL=" : process.env.REACT_APP_PRO_MODE + "/api/common/GetAttachbyURL?imageURL=";
  let image_url = marker1.farmerCropSurveyImageList.length != 0 ? marker1.farmerCropSurveyImageList[0].attPath : "" 

  let filteredImageHtml = `<div class="carousel-item active"><img src= ${image_url === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" :  base_url + image_url} class="d-block w-100" alt="..."/></div>`
   document.getElementById("AIFImageSlider").innerHTML = filteredImageHtml;


  let contentStringDASD = `<div class="table-responsive imgthumbnails">
  <button class="btn-close mapbtn" onclick="document.getElementById('infoDetailsDASD').style.display='none'"></button>
  <table class="table">
  <tr><th>Scheme Name : &nbsp</th><td>Directorate of Arecanut and Spices Development (DASD)</td></tr> 
  <tr><th>Component Name : &nbsp</th><td>${marker1.componentName}</td></tr>
  <tr><th>Survey No. : &nbsp</th><td>${marker1.surveyNo}</td></tr>
  <tr><th>Survey Date : &nbsp</th><td>${marker1.createdOn === "" || marker1.createdOn === "1900-01-01T00:00:00" ? "" : marker1.createdOn.split("T")[0]}</td></tr>
  <tr><th>State  : &nbsp</th><td>${marker1.stateName}</td></tr>
  <tr><th>District : &nbsp</th><td>${marker1.districtName}</td></tr>
  <tr><th>Sub District : &nbsp</th><td>${marker1.subDistrictName}</td></tr>
  <tr><th>Village : &nbsp</th><td>${marker1.villageName}</td></tr>
  <tr><th>Image :</th><td> <img alt="image" src= ${image_url === "" ? "https://krishimapper.dac.gov.in/imagenotfound.png" :  base_url + image_url} data-bs-toggle="modal" data-bs-target="#exampleModal" height="150px" width="150px"></img></td></tr>
  <tr><th colspan='2'><button class="btn btn-sm btn-danger mr-0 hideSoil" onclick="document.getElementById('infoDetailsDASD').style.display='none'">Close</button></th></tr>
  </table></div>`;  

  document.getElementById("infoDetailsDASD").style.display = "block";
  document.getElementById("infoDetailsDASD").innerHTML = contentStringDASD
 
};

function closeActiveMarker() {
  document.getElementById('infoDetailsCropic').style.display='none';
  setActiveMarkerPoint({})
  setActivePolygon("")
}

 function openMandtPopup(value) {

  const fetchMandTdata = async () => {

    let result;
    if(mandtFilter === "1") {
  
       result = await axios.post(`${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/Reverse/CommonAPI/Get_FMDBT_BYCHCPolygonIDHistory_GIS_Dashboard`, { "StrCHCHistoryUserID"  : value})

    }else {

       result = await axios.post(`${
        process.env.NODE_ENV === "development"
          ? process.env.REACT_APP_DEV_MODE
          : process.env.REACT_APP_PRO_MODE
      }/api/Reverse/CommonAPI/Get_FMDBT_BYCHCPolygonID_GIS_Dashboard`, { "strCHCUserid" : value})
    }
        // const result = await axios.post("https://km.amnex.co.in/appdevapi/api/Reverse/CommonAPI/Get_FMDBT_BYCHCPolygonID_GIS_Dashboard", {"strCHCUserid": value});
   
   
    if(result.data.data) {
let filteredImageHtmlPre = `<table class="table table-bordered"><thead><tr> <th>S.No</th><th >Implement Name</th></tr></thead><tbody>`

     let  filteredImageHtml = result.data.data.map((item, index) => {
        return   `<tr key=${index}><th scope="row">${index +1}</th>  <td>${item.implementSubsidyName}</td> </tr>`
      
    }).join('');

    let fullInnerHTML = filteredImageHtmlPre+  filteredImageHtml + " </tbody> </table>"

    console.log("filteredImageHtml", filteredImageHtmlPre+  filteredImageHtml + " </tbody> </table>")
    
     document.getElementById("AIFImageSliderM&T").innerHTML = fullInnerHTML;
  


      let data = <table className="table table-bordered">
         <thead>
        <tr>
          <th scope="col">S.No</th>
          <th scope="col">Implement Subsidy ID</th>
          <th scope="col">Implement Subsidy Name</th>
        </tr>
      </thead>
      <tbody>
        {result.data.data
          ? result.data.data.map((item, index) => {
              return (
                <tr key={index}>
                  <th scope="row">{index}</th>
                  <td>{item.seasonName}</td>
                  <td>{item.cropName}</td>
                
                </tr>
              );
            })
          : ""}
      </tbody>
    </table>

    console.log("data", data)

    // document.getElementById("exampleModal").style.display = "block";



    }
    setStatesData(result.data.dataContent);
  };
  fetchMandTdata();


console.log("mandt", value)


  // document.getElementById('infoDetailsCropic').style.display='none';
  // setActiveMarkerPoint({})
}





  $(".sidebar-dropdown > a").click(function() {
    $(".sidebar-submenu").slideUp(200);
    if (
      $(this)
        .parent()
        .hasClass("active")
    ) {
      $(".sidebar-dropdown").removeClass("active");
      $(this)
        .parent()
        .removeClass("active");
    } else {
      $(".sidebar-dropdown").removeClass("active");
      $(this)
        .next(".sidebar-submenu")
        .slideDown(200);
      $(this)
        .parent()
        .addClass("active");
    }
  });
  
  $("#close-sidebar").click(function() {
    $(".page-wrapper").removeClass("toggled");
  });
  $("#show-sidebar").click(function() {
    $(".page-wrapper").addClass("toggled");
  });



  return isLoaded ? (
    <>
 <aside id="myDIV" className="sidebar mapsidebar">

<div className="container">
<div className="row d-flex justify-content-center">
  <div className="col-md-12">
    <h3>Filter</h3>
    <p>Please select only 5 scheme at a time.</p>
  </div>
          <div className="col-md-12">
            <label htmlFor="inputScheme" className="form-label">
              Scheme
            </label>       
            <MultiSelect
              options={optionsScheme}
              value={selected}
              onChange={setSelected}
              labelledBy={"Select"}
              isCreatable={true}
              className="schemeSelect"
              id="schemeSelect"
              // className="form-select"
            />
          </div>
          { selected.some(el => el.value === "1") ? <div className="col-md-12">
            <label htmlFor="acabcFilter" className="form-label" id="acabcFilterLabel">
              ACABC
            </label>
            <select
              id="acabcFilter"
              required
              className="form-select"
              // onClick={getStates}
              onChange={(e) => setAcabcFilter(e.target.value)}
              value={acabcFilter}
              name="acabcFilter"
            >
              <option defaultValue value="NA">Choose...</option>
              <option defaultValue value="1">Nodal Training Institute</option>
              <option defaultValue value="2">Agriventure</option>
             
            </select>
          </div> : ""}
          { selected.some(el => el.value === "5") ? <div className="col-md-12">
            <label htmlFor="mandtFilter" className="form-label" id="mandtFilterLabel">
              M&T-CHC
            </label>
            <select
              id="mandtFilter"
              required
              className="form-select"
              // onClick={getStates}
              onChange={(e) => setMandtFilter(e.target.value)}
              value={mandtFilter}
              name="mandtFilter"
            >
              <option defaultValue value="NA">Choose...</option>
              <option defaultValue value="1">Source of Registration FarmsApp</option>
              <option defaultValue value="2">Source of Registration FMDBT (KM)</option>
             
            </select>
          </div> : ""}
          { selected.some(el => el.value === "6") ?    <div className="col-md-12">
            <label htmlFor="inputScheme" className="form-label">
              NBHM
            </label>       
            <MultiSelect
              options={optionsNBHM}
              value={selectedNBHM}
              onChange={setSelectedNBHM}
              labelledBy={"Select"}
              isCreatable={true}
              className="NBHMSelect"
              id="NBHMSelect"
              // className="form-select"
            />
          </div> : ""}
          <div className="col-md-12">
            <label htmlFor="State" className="form-label" id="StateLabel">
              State
            </label>
            <select
              id="State"
              required
              className="form-select"
              onClick={getStates}
              onChange={(e) => handleState(e.target.value)}
              value={stateValue}
              name="stateCode"
            >
              <option defaultValue value="NA">Choose...</option>
              {statesData
                ? statesData.map((item, id) => {
                    return (
                      <option key={id} value={item.stateCode}>
                        {" "}
                        {item.stateName}
                      </option>
                    );
                  })
                : ""}
            </select>
          </div>
          <div className="col-md-12">
            <label htmlFor="District" className="form-label" id="DistrictLabel">
              District
            </label>
            <select
              id="District"
              className="form-select"
              onChange={(e) => handleSubDistrict(e.target.value)}
              value={districtValue}
            >
              <option defaultValue value="NA">
                Choose...
              </option>

              {districtData
                ? districtData.map((item, id) => {
                    return (
                      <option key={id} value={item.districtCode}>
                        {" "}
                        {item.districtName}
                      </option>
                    );
                  })
                : ""}
            </select>
          </div>
          <div className="col-md-12">
            <label
              htmlFor="subDistrict"
              className="form-label"
              id="subDistrictLabel"
            >
              SubDistrict
            </label>
            <select
              id="subDistrict"
              className="form-select"
              onChange={(e) => handleBlock(e.target.value)}
              value={subDistrictValue}
            >
              <option defaultValue value="NA">
                Choose...
              </option>

              {subDistrictData.map((item, id) => {
                return (
                  <option key={id} value={item.subDistrictCode}>
                    {" "}
                    {item.subDistrictName}
                  </option>
                );
              })}
            </select>
          </div>
          <div className="col-md-12">
            <label htmlFor="Block" className="form-label" id="BlockLabel">
              Block
            </label>
            <select
              id="Block"
              className="form-select"
              onClick={handleVillage}
              onChange={(e) => setBlockValue(e.target.value)}
              value={blockValue}
            >
              <option defaultValue value="NA">
                Choose...
              </option>
              {blockData
                ? blockData.map((item, id) => {
                    return (
                      <option key={id} value={item.blockCode}>
                        {" "}
                        {item.blockName}
                      </option>
                    );
                  })
                : ""}
            </select>
          </div>
          <div className="col-md-12">
            <label htmlFor="inputVillage" className="form-label">
              Village
            </label>
            <select
              id="Village"
              className="form-select"
              // onClick={handleVillage}
              onChange={(e) => setVillageValue(e.target.value)}
              value={villageValue}
            >
              <option defaultValue value="NA">
                Choose...
              </option>
              {villageData
                ? villageData.map((item, id) => {
                    return (
                      <option key={id} value={item.villageCode}>
                        {" "}
                        {item.villageName}
                      </option>
                    );
                  })
                : ""}
            </select>        
          
          </div>
          <div className="col-md-12 d-flex justify-content-center">
              {" "}
              <button
                className="btn btn-success btn-sm mt-2"
                onClick={handleAddMarker}
              >
                {" "}
                Search
              </button>
              &nbsp;&nbsp;
              <button
                className="btn btn-info btn-sm mt-2 ml-5"
                onClick={handleClear}
              >
                Clear
              </button>
            </div>
        </div>

        {filterCall &&  <div className="col-md-12">
      
      <div id="legend">{selected.map((item, key) => {
      return    <div><img src={item.value === "1" && acabcFilter === "2" ? SkyBlueMarker : markerIcon[item.value] } alt={item.label}/> {item.label}<span ></span></div>
   })} </div>
   </div>
 
}

</div>
</aside>
 <div className="page-wrapper chiller-theme toggled">

   <main id="main" className="main">
        <div className="pagetitle page_title_box d-flex align-items-center justify-content-between mappaginations">
         
          <nav>
          <h1>GIS Dashboard</h1>
            <ol className="breadcrumb mapbreadcrumbs">
              <li className="breadcrumb-item">Admin</li>
              <li className="breadcrumb-item active">GISDashboard</li>
            </ol>
          </nav> 
  <Link className="btn btn-success" to="/AdminAccess">Dashboard</Link>
        </div>
       
    <div className="container-fluid">

    <div className="card">
      <div className="card-body">
      {/* <button onClick={handleHomeButton}>Home</button> */}
      <GoogleMap
           mapContainerStyle={containerStyle}
           center={center}
           zoom={mapZoom}
           onLoad={onLoad}
   
           // onUnmount={onUnmount}
            mapTypeId= "satellite"
         >
      
        {/* marker data */}

        
{ACABCData && ACABCData.map((data, index) => (<>
  {data.uIdentity == "3420" ? "" :
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.latitude),
              lng: parseFloat(data.longitude),
            }}
            icon={acabcFilter === "1" ? GreenMarker : SkyBlueMarker}
            onClick={() => handleMarkerClickACABC(data)}
          />}</>
        ))}

{agroforestryData && agroforestryData.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLat),
              lng: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLong),
            }}
            icon={YellowMarker}
            onClick={() => handleMarkerClickAgroforestry(data)}
          />
        ))}


{AIFData && AIFData.map((data, index) => (<>
  {data.geoImages.length === 0  ? "" :
          <Marker
          key={index}
          position={{
            lat: parseFloat(data.geoImages[0].geoLatitude),
            lng: parseFloat(data.geoImages[0].geoLongitude),
          }}
          icon={PinkHomeMarker}
          onClick={() => handleMarkerClickAIF(data)}
          />}</>
        ))}


{/* { AMIData && AMIData.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.geoImages[0].geoLatitude),
              lng: parseFloat(data.geoImages[0].geoLongitude),
            }}
            icon={GrayHomeMarker}
            onClick={() => handleMarkerClickAMI(data)}
          />
        ))} */}

{MANDTData && MANDTData.map((data, index) => (<>
         {data.chcUserId === "SHR-2019/00338" || data.chcUserId === "SHR-2019/00296" ? "" :  <Marker
            key={index}
            position={{
              lat: parseFloat(data.latitude),
              lng: parseFloat(data.longitude),
            }}
            icon={OrangeHomeMarker}
            onClick={() => handleMarkerClickMANDT(data)}
          />}</>
        ))}

{NBHMDataA && NBHMDataA.map((data, index) => (
  
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLat),
              lng: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLong),
            }}
            icon={GreenHomeMarker}
             onClick={() => handleMarkerClickNBHM(data, "1")}
          />
        ))}
        {NBHMDataB && NBHMDataB.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLat),
              lng: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLong),
            }}
            icon={GreenHomeMarker}
             onClick={() => handleMarkerClickNBHM(data, "2")}
          />
        ))}
        {NBHMDataC && NBHMDataC.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLat),
              lng: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLong),
            }}
            icon={GreenHomeMarker}
            onClick={() => handleMarkerClickNBHM(data, "3")}
          />
        ))}
        {NBHMDataD && NBHMDataD.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLat),
              lng: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLong),
            }}
            icon={GreenHomeMarker}
             onClick={() => handleMarkerClickNBHM(data, "4")}
          />
        ))}

{NFSMData && NFSMData.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.latitude),
              lng: parseFloat(data.longitude),
            }}
            icon={BlueMarker}
            onClick={() => handleMarkerClickNFSM(data)}
          />
        ))}

{NHBData && NHBData.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.polygons[0].lat),
              lng: parseFloat(data.polygons[0].lng),
            }}
            icon={PinkMarker}
            onClick={() => handleMarkerClickNHB(data)}
          />
        ))}


{NMEOData && NMEOData.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLat),
              lng: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLong),
            }}
            icon={PurpleMarker}
            onClick={() => handleMarkerClickNMEO(data)}
          />
        ))}
       
       {PDMCData && PDMCData.map((data, index) => (
            <Marker
            key={index}
            position={{
              lat: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLat),
              lng: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLong),
            }}
            icon={MergentaMarker}
            onClick={() => handleMarkerClickPDMC(data)}
          />
        ))}
       
       {RADData && RADData.map((data, index) => (
         data.farmerCropSurveyPolygonList.length === 0 ? "" : <Marker
            key={index}
            position={{
              lat: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLat),
              lng: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLong),
            }}
            icon={LitegreenMarker}
            onClick={() => handleMarkerClickRAD(data)}
          />
        ))}
       
       {SHCFarmerData && SHCFarmerData.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.coordinateslogitude),
              lng: parseFloat(data.coordinatesLatitude),
            }}
            icon={DarkGreenMarker}
            onClick={() => handleMarkerClickSHCFarmer(data)}
          />
        ))}


       
       {SHCLabData && SHCLabData.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.tcLatitude),
              lng: parseFloat(data.tcLongitude),
            }}
            icon={BlueHomeMarker}
            onClick={() => handleMarkerClickSHCLab(data)}
          />
        ))}

{cropicData && cropicData.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.surveyorLat),
              lng: parseFloat(data.surveyorLong),
            }}
            icon={DarkGrayMarker}
            onClick={() => handleMarkerClickCropic(data)}
          />
        ))}

{RKVYData && RKVYData.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.latitude),
              lng: parseFloat(data.longitude),
            }}
            label = {data.total}
            icon={data.total ? BlueCircle : PurpleHomeMarker}
            onClick={() => handleMarkerClickRKVY(data)}
          />
        ))}
{NaturalFarmingData && NaturalFarmingData.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.farmerCropSurveryPolygon[0].surveyorLat),
              lng: parseFloat(data.farmerCropSurveryPolygon[0].surveyorLong),
            }}
            icon={LightPurpleMarker}
            onClick={() => handleMarkerClickNaturalFarming(data)}
          />
        ))}
{MIDHData && MIDHData.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLat),
              lng: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLong),
            }}
            icon={DarkPurpleMarker}
            onClick={() => handleMarkerClickMIDH(data)}
          />
        ))}

{MOVCDData && MOVCDData.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLat),
              lng: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLong),
            }}
            icon={LightPinkMarker}
            onClick={() => handleMarkerClickMOVCD(data)}
          />
        ))}
{NPSSData && NPSSData.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.latitude),
              lng: parseFloat(data.longitude),
            }}
            icon={SuperDarkGreenMarker}
            onClick={() => handleMarkerClickNPSS(data)}
          />
        ))}

{CottonData && CottonData.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.surveyorLat),
              lng: parseFloat(data.surveyorLong),
            }}
            icon={LiteBlueMarker}
            onClick={() => handleMarkerClickCotton(data)}
          />
        ))}

{SeedHubData && SeedHubData.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.latitude),
              lng: parseFloat(data.longitude),
            }}
            label = {data.total}
            icon={data.total ? BlueCircle : PurpleHomeMarker}
            onClick={() => handleMarkerClickSeedHub(data)}
          />
        ))}

{CDBData && CDBData.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLat),
              lng: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLong),
            }}
            icon={LightPinkMarker}
            onClick={() => handleMarkerClickCDB(data)}
          />
        ))}

{DASDData && DASDData.map((data, index) => (
          <Marker
            key={index}
            position={{
              lat: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLat),
              lng: parseFloat(data.farmerCropSurveyPolygonList[0].surveyorLong),
            }}
            icon={LightPinkMarker}
            onClick={() => handleMarkerClickDASD(data)}
          />
        ))}

{activeMarkerPoint != {} ?
          <Marker
          
            position={{
              lat: parseFloat(activeMarkerPoint.lat),
              lng: parseFloat(activeMarkerPoint.long),
            }}
            // icon={DarkGrayMarker}
            // onClick={() => handleMarkerClickCropic(data)}
          /> : ""
        } 


{activePolygon && 
             <Polygon
             
              paths={JSON.parse(activePolygon)}
              options={{
                fillColor: '#008000',
                fillOpacity: 0.35,
                strokeColor: '#008000',
                strokeOpacity: 0.8,
                strokeWeight: 2,
              }}
              // onClick={() => handlePolygonData(polygonPaths)}
            /> 
          } 

       
       

{ACABCPolygonData && ACABCPolygonData.map((polygonPaths, index) => (
             <Polygon
              key={index}
              paths={polygonPaths}
              options={{
                fillColor: '#008000',
                fillOpacity: 0.35,
                strokeColor: '#008000',
                strokeOpacity: 0.8,
                strokeWeight: 2,
              }}
              // onClick={() => handlePolygonData(polygonPaths)}
            />
          ))} 

{agroforestryPolygonData && agroforestryPolygonData.map((polygonPaths, index) => (
             <Polygon
              key={index}
              paths={polygonPaths}
              options={{
                fillColor: '#FFFF00',
                fillOpacity: 0.35,
                strokeColor: '#FFFF00',
                strokeOpacity: 0.8,
                strokeWeight: 2,
              }}
              // onClick={() => handlePolygonData(polygonPaths)}
            />
          ))} 
          {NHBPolygonData && NHBPolygonData.map((polygonPaths, index) => (
            <>
            {console.log("NHBPolygonData", polygonPaths)}
             <Polygon
              key={index}
              paths={polygonPaths}
              options={{
                fillColor: '#FFC0CB',
                fillOpacity: 0.35,
                strokeColor: '#FFC0CB',
                strokeOpacity: 0.8,
                strokeWeight: 2,
              }}
              // onClick={() => handlePolygonData(polygonPaths)}
            />
            </>
            
          ))} 
          {NMEOPolygonData && NMEOPolygonData.map((polygonPaths, index) => (
             <Polygon
              key={index}
              paths={polygonPaths}
              options={{
                fillColor: '#A020F0',
                fillOpacity: 0.35,
                strokeColor: '#A020F0',
                strokeOpacity: 0.8,
                strokeWeight: 2,
              }}
              // onClick={() => handlePolygonData(polygonPaths)}
            />
          ))} 
          {PDMCPolygonData && PDMCPolygonData.map((polygonPaths, index) => (
             <Polygon
              key={index}
              paths={polygonPaths}
              options={{
                fillColor: '#FF00FF',
                fillOpacity: 0.35,
                strokeColor: '#FF00FF',
                strokeOpacity: 0.8,
                strokeWeight: 2,
              }}
              // onClick={() => handlePolygonData(polygonPaths)}
            />
          ))} 
          {RADPolygonData && RADPolygonData.map((polygonPaths, index) => (
             <Polygon
              key={index}
              paths={polygonPaths}
              options={{
                fillColor: '#00FF00',
                fillOpacity: 0.35,
                strokeColor: '#00FF00',
                strokeOpacity: 0.8,
                strokeWeight: 2,
              }}
              // onClick={() => handlePolygonData(polygonPaths)}
            />
          ))} 
             {NFSMPolygonData && NFSMPolygonData.map((polygonPaths, index) => (
             <Polygon
              key={index}
              paths={polygonPaths}
              options={{
                fillColor: '#0000FF',
                fillOpacity: 0.35,
                strokeColor: '#0000FF',
                strokeOpacity: 0.8,
                strokeWeight: 2,
              }}
              // onClick={() => handlePolygonData(polygonPaths)}
            />
          ))} 
             {SHCFarmerPolygonData && SHCFarmerPolygonData.map((polygonPaths, index) => (
             <Polygon
              key={index}
              paths={polygonPaths}
              options={{
                fillColor: '#013220',
                fillOpacity: 0.35,
                strokeColor: '#013220',
                strokeOpacity: 0.8,
                strokeWeight: 2,
              }}
              // onClick={() => handlePolygonData(polygonPaths)}
            />
          ))}  

{cropicPolygonData && cropicPolygonData.map((polygonPaths, index) => (
             <Polygon
              key={index}
              paths={polygonPaths}
              options={{
                fillColor: '#0000FF',
                fillOpacity: 0.35,
                strokeColor: '#013220',
                strokeOpacity: 0.8,
                strokeWeight: 2,
              }}
              // onClick={() => handlePolygonData(polygonPaths)}
            />
          ))} 
    
    {naturalFarmingPolygonData && naturalFarmingPolygonData.map((polygonPaths, index) => (
             <Polygon
              key={index}
              paths={polygonPaths}
              options={{
                fillColor: '#0000FF',
                fillOpacity: 0.35,
                strokeColor: '#013220',
                strokeOpacity: 0.8,
                strokeWeight: 2,
              }}
              // onClick={() => handlePolygonData(polygonPaths)}
            />
          ))} 

{NBHMDPolygonData && NBHMDPolygonData.map((polygonPaths, index) => (
             <Polygon
              key={index}
              paths={polygonPaths}
              options={{
                fillColor: '#0000FF',
                fillOpacity: 0.35,
                strokeColor: '#013220',
                strokeOpacity: 0.8,
                strokeWeight: 2,
              }}
              // onClick={() => handlePolygonData(polygonPaths)}
            />
          ))} 
          {MIDHPolygonData && MIDHPolygonData.map((polygonPaths, index) => (
             <Polygon
              key={index}
              paths={polygonPaths}
              options={{
                fillColor: '#00FFFF',
                fillOpacity: 0.35,
                strokeColor: '#013220',
                strokeOpacity: 0.8,
                strokeWeight: 2,
              }}
              // onClick={() => handlePolygonData(polygonPaths)}
            />
          ))} 
          {MOVCDPolygonData && MOVCDPolygonData.map((polygonPaths, index) => (
             <Polygon
              key={index}
              paths={polygonPaths}
              options={{
                fillColor: '#FF00FF',
                fillOpacity: 0.35,
                strokeColor: '#013220',
                strokeOpacity: 0.8,
                strokeWeight: 2,
              }}
              // onClick={() => handlePolygonData(polygonPaths)}
            />
          ))} 
              {CottonPolygonData && CottonPolygonData.map((polygonPaths, index) => (
             <Polygon
              key={index}
              paths={polygonPaths}
              options={{
                fillColor: '#FF0000',
                fillOpacity: 0.35,
                strokeColor: '#013220',
                strokeOpacity: 0.8,
                strokeWeight: 2,
              }}
              // onClick={() => handlePolygonData(polygonPaths)}
            />
          ))} 

{console.log("CDBPolygonData $$", CDBPolygonData)}
        {CDBPolygonData && CDBPolygonData.map((polygonPaths, index) => (
                    <Polygon
                      key={index}
                      paths={polygonPaths}
                      options={{
                        fillColor: '#FF00FF',
                        fillOpacity: 0.35,
                        strokeColor: '#013220',
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                      }}
                      // onClick={() => handlePolygonData(polygonPaths)}
                    />
                  ))} 

   {DASDPolygonData && DASDPolygonData.map((polygonPaths, index) => (
                    <Polygon
                      key={index}
                      paths={polygonPaths}
                      options={{
                        fillColor: '#FF00FF',
                        fillOpacity: 0.35,
                        strokeColor: '#013220',
                        strokeOpacity: 0.8,
                        strokeWeight: 2,
                      }}
                      // onClick={() => handlePolygonData(polygonPaths)}
                    />
                  ))} 

         </GoogleMap>
      </div>
    </div>
     

    </div>

    <div className="modal fade" id="counts" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="exampleModalLabel">Total Records</h5>
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
      </div>
      <div className="modal-body" id="count">
      {selected.map((item) => {
      
      return <div className="d-flex justify-content-between"> <span>{labelName[item.value] + " :-"}</span>&nbsp;&nbsp;&nbsp;<span id={item.value} style={{fontWeight: 'bold'}}></span></div>
      
    })}
      </div>
    
    </div>
  </div>
</div>

{loader === false ? "" : <div class="overlay">
    <div class="overlay__inner">
        <div class="overlay__content"><span class="spinner"></span></div>
    </div>
</div>}
{loaderNFSM === false ? "" : <div class="overlay">
    <div class="overlay__inner">
        <div class="overlay__content"><span class="spinner"></span></div>
    </div>
</div>}

{loaderCropic === false ? "" : <div class="overlay">
    <div class="overlay__inner">
        <div class="overlay__content"><span class="spinner"></span></div>
    </div>
</div>}

{loaderAIF === false ? "" : <div class="overlay">
    <div class="overlay__inner">
        <div class="overlay__content"><span class="spinner"></span></div>
    </div>
</div>}

{loaderPDMC === false ? "" : <div class="overlay">
    <div class="overlay__inner">
        <div class="overlay__content"><span class="spinner"></span></div>
    </div>
</div>}

{loaderCotton === false ? "" : <div class="overlay">
    <div class="overlay__inner">
        <div class="overlay__content"><span class="spinner"></span></div>
    </div>
</div>}

{LoaderSeedHub === false ? "" : <div class="overlay">
    <div class="overlay__inner">
        <div class="overlay__content"><span class="spinner"></span></div>
    </div>
</div>}
{LoaderCDB === false ? "" : <div class="overlay">
    <div class="overlay__inner">
        <div class="overlay__content"><span class="spinner"></span></div>
    </div>
</div>}
{LoaderDASD === false ? "" : <div class="overlay">
    <div class="overlay__inner">
        <div class="overlay__content"><span class="spinner"></span></div>
    </div>
</div>}

  </main>
 <div className="printbtns">
 <button className="bg-transparent text-white" data-bs-toggle="modal" data-bs-target="#counts"><img src={number}/> </button>
    {/* <button className="bg-transparent text-white" onClick={() => window.print()}><img src={prints}/> </button> */}
  </div>  
      <div id="infoDetailsACABC"></div>
      <div id="infoDetailsAgroforestry"></div>
      <div id="infoDetailsAIF"></div>
      <div id="infoDetailsAMI"></div>
      <div id="infoDetailsMANDT"></div>
      <div id="infoDetailsNBHM"></div>
      <div id="infoDetailsNFSM"></div>
      <div id="infoDetailsNHB"></div>
      <div id="infoDetailsNMEO"></div>
      <div id="infoDetailsPDMC"></div>
      <div id="infoDetailsRAD"></div>
      <div id="infoDetailsSHCFarmer"></div>
      <div id="infoDetailsSHCLab"></div>
      <div id="infoDetailsCropic"></div>
      <div id="infoDetailsRKVY"></div>
      <div id="infoDetailsNaturalFarming"></div>
      <div id="infoDetailsMIDH"></div>
      <div id="infoDetailsMOVCD"></div>
      <div id="infoDetailsNPSS"></div>
      <div id="infoDetailsCotton"></div>
      <div id="infoDetailsSeedHub"></div>
      <div id="infoDetailsCDB"></div>
      <div id="infoDetailsDASD"></div>

   



        
</div>

{/* AIF POPUP */}

<div className="modal fade ImageSliderPopUP" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        {/* <h5 className="modal-title" id="exampleModalLabel">AIF Survey Screens</h5> */}
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
      </div>
      <div className="modal-body">
      <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner AIFImageSliderClass" id="AIFImageSlider">
   
  </div>
  {/* <button id="button">Click me!</button> */}
  <button className="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev" id="prevBtn">
    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Previous</span>
  </button>
  <button className="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next" id="nextBtn">
    <span className="carousel-control-next-icon" aria-hidden="true"></span>
    <span className="visually-hidden">Next</span>
  </button>
</div>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

{/* M&T Popup */}

<div className="modal fade ImageSliderPopUP" id="exampleModalMandT" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        {/* <h5 className="modal-title" id="exampleModalLabel">AIF Survey Screens</h5> */}
        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">X</button>
      </div>
      <div className="modal-body">
      <div id="carouselExampleControls" className="carousel slide" data-bs-ride="carousel">
  <div className="carousel-inner" id="AIFImageSliderM&T">
   
  </div>

</div>
      </div>
      <div className="modal-footer">
        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>


     
    </>
  ): (
    <></>
  );
}

export default React.memo(MyComponent);
